{
	"metadata": {
		"version": "81"
	  },
    "bs": {
        "are": {
            "b": {
                "en": "buying", 
                "fr": "acheter", 
                "it": "acquistare", 
                "ja": "買い", 
                "ru": "покупаете", 
                "tr": "satın alma", 
                "uk": "купуєте", 
                "zh": "购买"
            }, 
            "s": {
                "en": "selling", 
                "fr": "vendre", 
                "it": "vendere", 
                "ja": "売り", 
                "ru": "продаете", 
                "tr": "satış", 
                "uk": "продаєте", 
                "zh": "售卖"
            }
        }, 
        "bs": {
            "b": {
                "en": "Buy", 
                "fr": "Acheter", 
                "it": "Acquista", 
                "ja": "買い", 
                "ru": "Купить", 
                "tr": "Alış", 
                "uk": "Купити", 
                "zh": "购买"
            }, 
            "s": {
                "en": "Sell", 
                "fr": "Vendre", 
                "it": "Vendi", 
                "ja": "売り", 
                "ru": "Продать", 
                "tr": "Satma", 
                "uk": "Продати", 
                "zh": "出售"
            }
        }, 
        "ls": {
            "b": {
                "en": "Long", 
                "fr": "Achat", 
                "it": "Acquistare", 
                "ja": "購入", 
                "ru": "Лонги", 
                "tr": "Alım", 
                "uk": "Купівля", 
                "zh": "购买"
            }, 
            "s": {
                "en": "Short", 
                "fr": "Vente", 
                "it": "Vendita", 
                "ja": "販売", 
                "ru": "Шорты", 
                "tr": "Satış", 
                "uk": "Продаж", 
                "zh": "特价"
            }
        },
        "noun": {
            "b": {
                "en": "Purchase", 
                "fr": "Achat", 
                "it": "Acquistare", 
                "ja": "購入", 
                "ru": "Покупка", 
                "tr": "Alım", 
                "uk": "Купівля", 
                "zh": "购买"
            }, 
            "s": {
                "en": "Sale", 
                "fr": "Vente", 
                "it": "Vendita", 
                "ja": "販売", 
                "ru": "Продажа", 
                "tr": "Satış", 
                "uk": "Продаж", 
                "zh": "特价"
            }
        }, 
        "order": {
            "all": {
                "en": ""
            }, 
            "b": {
                "en": "buy", 
                "fr": "acheter", 
                "it": "acquista", 
                "ja": "買う", 
                "ru": "покупки", 
                "tr": "alış", 
                "uk": "покупки", 
                "zh": "购买"
            }, 
            "s": {
                "en": "sell", 
                "fr": "vendre", 
                "it": "vendi", 
                "ja": "売る", 
                "ru": "продажи", 
                "tr": "satma", 
                "uk": "продажі", 
                "zh": "出售"
            }
        }, 
        "want": {
            "b": {
                "en": "to buy", 
                "fr": "acheter", 
                "it": "Da acquistare", 
                "ja": "購入", 
                "ru": "купить", 
                "tr": "satın almak", 
                "uk": "купити", 
                "zh": "去买"
            }, 
            "s": {
                "en": "to sell", 
                "fr": "vendre", 
                "it": "Da vendere", 
                "ja": "売却", 
                "ru": "продать", 
                "tr": "satmak", 
                "uk": "продати", 
                "zh": "出售"
            }
        }, 
        "was": {
            "b": {
                "en": "bought", 
                "fr": "acheté", 
                "it": "acquistati", 
                "ja": "購入済み", 
                "ru": "куплено", 
                "tr": "satın alınmış", 
                "uk": "куплено", 
                "zh": "买了"
            }, 
            "s": {
                "en": "sold", 
                "fr": "vendu", 
                "it": "venduti", 
                "ja": "売却済み", 
                "ru": "продано", 
                "tr": "satılmış", 
                "uk": "продано", 
                "zh": "已出售"
            }
        }
    },
	"versionChanges": {
		"2.276.1.70": {
			"en": "PMA Dashboard now shows a chart with performance and volume; Any token with balance less than Minimal Trading volume can be converted to A2A tokens, use Menu-> Wallets-> Token Info-> [Convert to A2A]",
			"de": "Das PMA-Dashboard zeigt jetzt ein Diagramm mit Leistung und Volumen an; Jeder Token mit einem Guthaben von weniger als dem minimalen Handelsvolumen kann in A2A-Token konvertiert werden. Verwenden Sie dazu Menu-> Wallets-> Token Info-> [In A2A konvertieren].",
			"ko": "PMA 대시 보드는 이제 성능 및 볼륨이있는 차트를 표시합니다; 잔액이 최소 거래량 미만인 모든 토큰은 A2A 토큰으로 변환 할 수 있습니다. 메뉴-> 지갑-> 토큰 정보-> [A2A로 변환]을 사용하십시오.",
			"ru": "Инфопанель PMA теперь показывает диаграмму с производительностью и объемом; Любой токен с балансом меньше минимального торгового объема может быть преобразован в токены A2A, используйте Меню-> Кошельки-> Информация о токене-> [Конвертировать в A2A]"
		},
		"2.277.1.70": {
			"en": "Master Key can be shown again (in case you lost it) on the Menu-> Settings page; [Save] button on the chart allows you to save your chart drawings. They are also saved automatically each time you change trading pair.",
			"de": "Der Hauptschlüssel kann auf der Seite Menu-> Einstellungen erneut angezeigt werden (falls Sie ihn verloren haben); Mit der Schaltfläche [Speichern] im Diagramm können Sie Ihre Diagrammzeichnungen speichern. Sie werden auch jedes Mal automatisch gespeichert, wenn Sie das Handelspaar ändern.",
			"ko": "마스터 키는 Menu-> 설정 페이지에서 다시 표시 할 수 있습니다 (분실 한 경우); 차트의 [저장] 버튼을 누르면 차트 도면을 저장할 수 있습니다. 또한 거래 쌍을 변경할 때마다 자동으로 저장됩니다.",
			"ru": "Мастер-ключ может быть снова показан (на случай его утери) на странице Menu-> Settings; Кнопка [Сохранить] на графике позволяет сохранить чертежи графика. Они также автоматически сохраняются каждый раз, когда вы меняете торговую пару."
		},
		"3.282.247_t.83": {
			"en": "The terminal kernel has been rewritten and moved to web components. Increased speed. Switching between tabs, switching between pages is faster. Improved the mobile view of the terminal. Changed the design of modules / pages. The order history is loaded completely, not just the last 1000 orders. Improved color customization system. Many fixes, improvements. Added work with liquidity pools through the PMA system.",
			"de": "Der Terminalkern wurde neu geschrieben und in Webkomponenten verschoben. Erhöhte Geschwindigkeit. Das Wechseln zwischen Registerkarten und das Wechseln zwischen Seiten ist schneller. Die mobile Ansicht des Terminals wurde verbessert. Modifiziertes Design von Modulen / Seiten. Die Bestellhistorie wird komplett geladen, nicht nur die letzten 1000 Bestellungen. Verbessertes Farbanpassungssystem. Viele Korrekturen, Verbesserungen. Arbeit mit Liquiditätspools durch das PMA-System hinzugefügt.",
			"ko": "터미널 코어가 다시 작성되고 웹 구성 요소로 이동되었습니다. 속도 증가. 탭 간 전환, 페이지 간 전환이 더 빠릅니다. 단말기의 모바일 보기가 개선되었습니다. 모듈/페이지의 수정된 디자인. 주문 내역은 최근 1000개 주문뿐만 아니라 완전히 로드됩니다. 향상된 색상 사용자 정의 시스템. 많은 수정, 개선. PMA 시스템을 통해 유동성 풀 작업을 추가했습니다.",
			"zh": "终端核心已被重写并移至 Web 组件。速度提高。在标签之间切换，页面之间切换更快。改进了终端的移动视图。模块/页面的修改设计。订单历史已完全加载，而不仅仅是最后 1000 个订单。改进的颜色定制系统。许多修复，改进。通过 PMA 系统增加了流动性池的工作。",
			"ru": "Переписано ядро терминала перенесено на веб-компоненты. Повышена скорость. Переход между вкладками, переключение между страницами выполняется быстрее. Улучшен мобильный вид терминала. Изменен дизайн модулей/страниц. История ордеров загружается полностью, а не только последние 1000 ордеров. Улучшена система кастомизации цветов. Множество фиксов, доработок. Добавлена работа с пулами ликвидности через систему PMA."
		}
	},
    "message": {
        "pma_deposit_closed": {
            "help": "{0}=pma_name, {1}=dep_id, {2}=sym_list",
            "en": "🇬🇧[EN] Your {0} PMA deposit {1} has been closed. Funds has been credited to your account in {2}.",
            "ru": "🇷🇺[RU] Ваш депозит {1} в PMA {0} закрыт. средства выведены и зачислены на ваш аккаунт в {2}."
        },
        "aml_warning": {
            "en": "🇬🇧[EN] We have recorded the use of the exchange as a mixer from your account. Such actions are prohibited by the USER AGREEMENT (clause 9.8) and, if repeated, will result in the blocking of your account and funds.",
            "de": "🇩🇪[DE] Wir haben die Verwendung der Börse als Mixer von Ihrem Konto erfasst. Solche Aktionen sind durch die BENUTZERVEREINBARUNG (Ziffer 9.8) verboten und führen bei Wiederholung zur Sperrung Ihres Kontos und Ihres Guthabens.",
            "it": "🇮🇹[IT] Abbiamo registrato l'utilizzo dell'exchange come mixer dal tuo account. Tali azioni sono proibite dal CONTRATTO CON L'UTENTE (clausola 9.8) e, se ripetute, comporteranno il blocco del tuo account e dei tuoi fondi.",
            "fr": "🇫🇷[FR] Nous avons enregistré l'utilisation de l'échange en tant que mélangeur à partir de votre compte. De telles actions sont interdites par le CONTRAT D'UTILISATION (clause 9.8) et, si elles sont répétées, entraîneront le blocage de votre compte et de vos fonds.",
            "ja": "🇯🇵[JA] 私たちはあなたのアカウントからミキサーとしての取引所の使用を記録しました。このような行為はユーザー契約（9.8節）によって禁止されており、繰り返されると、アカウントと資金がブロックされます。",
            "ko": "🇰🇷[KO] 귀하의 계정에서 거래소를 믹서로 사용하는 것을 기록했습니다. 이러한 행위는 사용자 계약 (9.8 절)에 의해 금지되며 반복 될 경우 귀하의 계정과 자금이 차단됩니다.",
            "tr": "🇹🇷[TR]Değişimin kullanımını hesabınızdan bir karıştırıcı olarak kaydettik. Bu tür eylemler KULLANICI SÖZLEŞMESİ (madde 9.8) tarafından yasaklanmıştır ve tekrarlanırsa, hesabınızın ve paranızın bloke edilmesi ile sonuçlanacaktır.",
            "uk": "🇺🇦[UK]Ми зафіксували використання біржі як змішувача з вашого рахунку. Такі дії заборонені УГОДНОЮ УГОДОЮ (пункт 9.8) і, якщо їх повторити, це призведе до блокування вашого рахунку та коштів.",
            "zh": "🇨🇳[ZH] 我们已经从您的帐户记录了交易所作为搅拌机的使用。用户协议（第9.8条）禁止此类操作，如果重复执行，将导致您的帐户和资金被冻结。",
            "ru": "🇷🇺[RU] Мы зафиксировали использование биржи в качестве миксера с вашего аккаунта. Подобные действия запрещены ПРАВИЛАМИ ИСПОЛЬЗОВАНИЯ (пунтк 9.8) и в случае повторения, повлекут за собой блокировку вашего аккаунта и средств."
        },
        "all_newFeature": {
            "help": "{0}=version, {1}=link",
            "en": "🇬🇧[EN]🆕 New features have been added to the system in {0} version at {1}",
            "de": "🇩🇪[DE]🆕 Das System wurde um neue Funktionen in Version {0} auf {1} erweitert",
            "it": "🇮🇹[IT]🆕 Nuove funzionalità sono state aggiunte al sistema nella versione {0} su {1}",
            "fr": "🇫🇷[FR]🆕 De nouvelles fonctionnalités ont été ajoutées au système dans la version {0} disponible sur {1}",
            "ja": "🇯🇵[JA]🆕 {1} の{0}バージョンのシステムに新しい機能が追加されました：",
            "ko": "🇰🇷[KO]🆕 {1} 의 {0} 버전에서 시스템에 새로운 기능이 추가되었습니다.",
            "tr": "🇹🇷[TR]🆕 {1} öğesindeki {0} sürümünde sisteme yeni özellikler eklenmiştir",
            "uk": "🇺🇦[UK]🆕 У версії {0} торгового терміналу, доступного на {1} з'явилися нові функції:",
            "zh": "🇨🇳[ZH]🆕 已在位于 {1} 的{0}版本中向系统添加了新功能：",
            "ru": "🇷🇺[RU]🆕 В версии {0} торгового терминала, доступной на {1} появились новые функции:"
        },
        "all_update": {
            "help": "НЕДОДЕЛАНО! {0}=version, {1}=link",
            "en": "🇬🇧[EN] Mobile-compatible trading terminal has been updated to {0} version at {1}.",
            "fr": "🇫🇷[FR] Un terminal commercial compatible pour mobile a été mis à jour en version {0} sur {1}.",
            "it": "🇮🇹[IT] Il terminale di trading compatibile con i dispositivi mobili è stato aggiornato alla versione {0} su {1}.",
            "ja": "モバイル対応取引端末が、{1}で{0}バージョンに更新されました。",
            "ru": "Мобильно-совместимый торговый терминал обновлен до версии {0} и доступен на {1}",
            "test": "Mobile-compatible trading terminal has been updated to {0} version at {1}.",
            "tr": "Mobil uyumlu alım satım terminali {1} öğesindeki {0} sürümüne güncellenmiştir.",
            "uk": "Мобільноо-сумісний торговий термінал оновлений до версії {0} і доступний на {1}.",
            "zh": "移动兼容交易终端已更新到{1}上的{0}版本。"
        },
        "all_updateBeta": {
            "help": "НЕДОДЕЛАНО! {0}=version, {1}=link",
            "en": "🇬🇧[EN] Beta version of the trading terminal has been updated at {1} . Current version is {0}.",
            "fr": "🇫🇷[FR] La version bêta du terminal commercial a été mise à jour sur {1}. La version actuelle est {0}.",
            "it": "🇮🇹[IT] La versione beta del terminale di trading è stata aggiornata su {1}. La versione corrente è {0}.",
            "ja": "取引端末のベータ版が{1}で更新されました。現在のバージョンは{0}です。",
            "ru": "Бета-версия мобильно-совместимого торгового терминала обновлена до версии {0} и доступна на {1}",
            "test": "Beta version of the trading terminal has been updated at {1} . Current version is {0}.",
            "tr": "Alım satım terminalinin beta sürümü {1} adresinde güncellenmiştir. {0} mevcut sürümdür.",
            "uk": "Бета-версія мобільно-сумісного торгового терміналу оновлена на {0} і доступна на {1}.",
            "zh": "交易终端的测试版已在{1}更新。当前版本是{0}。"
        },
        "all_updateMobile": {
            "help": "НЕДОДЕЛАНО! {0}=version, {1}=link, {2}=platform",
            "en": "🇬🇧[EN] Mobile {2} app has been updated to {0} version. Available at {1}",
            "fr": "🇫🇷[FR] L'application mobile pour {2} a été mise à jour en version {0}. Disponible sur {1}",
            "it": "🇮🇹[IT] L'app {2} per dispositivi mobili è stata aggiornata alla versione {0}. Disponibile su {1}",
            "ja": "モバイル{2}アプリが{0}バージョンに更新されました。{1}から利用できます。",
            "ru": "Мобильное {2} приложение обновлено до версии {0} и доступено на {1}",
            "test": "Mobile {2} app has been updated to {0} version. Available at {1}",
            "tr": "Mobil {2} uygulaması {0} sürümüne güncellenmiştir. {1} adresinde kullanıma hazırdır",
            "uk": "Мобільний {2} додаток оновлений до версії {0} і доступно на {1}",
            "zh": "移动{2}应用程序已更新为{0}版本。位于{1}"
        },
        "all_PMAlisted": {
            "help": "No parameters",
            "en": "🇬🇧[EN] New PMA's have been listed on 50x.com. Professional Master Account (PMA) is the easiest and safest way to give your funds to other traders in exchange for a share of the profit. Learn more at https://trade.50x.com/webapp/en/pma-list",
            "de": "🇩🇪[DE] Neue PMAs wurden auf 50x.com gelistet. Das Professional Master Account (PMA) ist der einfachste und sicherste Weg, Ihr Geld anderen Händlern gegen einen Teil des Gewinns zu geben. Erfahren Sie mehr unter https://trade.50x.com/webapp/en/pma-list",
            "fr": "🇫🇷[FR] De nouveaux PMA ont été répertoriés sur 50x.com. Le compte principal professionnel (PMA) est le moyen le plus simple et le plus sûr de donner vos fonds à d'autres traders en échange d'une part des bénéfices. En savoir plus sur https://trade.50x.com/webapp/fr/pma-list",
            "it": "🇮🇹[IT] I nuovi PMA sono stati elencati su 50x.com. Professional Master Account (PMA) è il modo più semplice e sicuro per dare i tuoi fondi ad altri trader in cambio di una quota del profitto. Ulteriori informazioni su https://trade.50x.com/webapp/it/pma-list",
            "ja": "🇯🇵[JA] 新しいPMAは50x.comにリストされています。プロフェッショナルマスターアカウント（PMA）は、利益の一部と引き換えに他のトレーダーに資金を提供するための最も簡単で安全な方法です。 https://trade.50x.com/webapp/en/pma-list で詳細をご覧ください",
            "ko": "🇰🇷[KO] 새로운 PMA는 50x.com에 등록되었습니다. 프로페셔널 마스터 계좌 (PMA)는 이익의 일부를받는 대가로 다른 거래자에게 자금을 제공하는 가장 쉽고 안전한 방법입니다. https://trade.50x.com/webapp/ko/pma-list 에서 자세히 알아보기",
            "tr": "🇹🇷[TR] Yeni PMA'lar 50x.com'da listelenmiştir. Profesyonel Ana Hesap (PMA), kârdan bir pay karşılığında fonlarınızı diğer tüccarlara vermenin en kolay ve en güvenli yoludur. https://trade.50x.com/webapp/tr/pma-list 'de daha fazla bilgi edinin.",
            "uk": "🇺🇦[UK] Нові PMA були перераховані на 50x.com. Професійний майстер-рахунок (PMA) - це найпростіший і найбезпечніший спосіб передати свої кошти іншим трейдерам в обмін на частку прибутку. Дізнайтеся більше на https://trade.50x.com/webapp/en/pma-list",
            "zh": "🇨🇳[ZH] 新的PMA已在50x.com上列出。专业总账户（PMA）是将您的资金分配给其他交易者以换取一部分利润的最简单，最安全的方法。在 https://trade.50x.com/webapp/en/pma-list 了解更多",
            "ru": "🇷🇺[RU] Новые PMA размещены на 50x.com. Профессиональный мастер-счет (PMA) - это самый простой и безопасный способ передать ваши средства другим трейдерам в обмен на долю прибыли. Узнайте больше на https://trade.50x.com/webapp/ru/pma-list"
        },
        "all_listed": {
            "help": "{0}=sym, {1}=name, {2}=link",
            "en": "🇬🇧[EN] {1} has been listed on 50x.com with {0} ticker. Learn more about {1} at {2}",
            "de": "🇩🇪[DE] {1} wurde auf 50x.com mit dem Ticker {0} aufgeführt. Erfahren Sie mehr über {1} unter {2}",
            "fr": "🇫🇷[FR] Le {1} est coté sur 50x.com avec le symbole {0}. En savoir plus sur {1} à {2}",
            "it": "🇮🇹[IT] Il {1} è stato elencato su 50x.com con il ticker {0}. Ulteriori informazioni su {1} su {2}",
            "ja": "🇯🇵[JA] {1} トークンは50x.comでティッカーシンボル {0} として取引されています。{1}についての詳細は{2}からご確認ください。",
            "ko": "🇰🇷[KO] {1} 토큰이 50x.com 에 상장되었습니다.(기호: {0}) {1}에 대해 더 알아보기 {2}",
            "tr": "🇹🇷[TR] {1}  50x.com adresinde {0} kodu ile listelenmiştir. {1} hakkında daha fazla bilgiyi {2} öğesinde bulabilirsiniz",
            "uk": "🇺🇦[UK] {1} був залістений на 50x.com під тікером {0}. Докладніше про {1} читайте на {2}",
            "zh2": "{1}令牌已在50x.com上用{0}ticker列出。在 {2} 了解有关{1}的更多信息",
            "zh": "🇨🇳[ZH] {1}代币已在50x.com上用{0}股票行情列出。在 {2} 了解有关{1}的更多信息",
            "ru": "🇷🇺[RU] {1} добавлен на 50x.com под тикером {0}. Подробнее о {1} читайте на {2}"
        },
        "all_delisted": {
            "help": "{0}=sym, {1}=deadline",
            "en": "🇬🇧[EN]🚮 {0} has been delisted from 50x.com exchange. All orders in {0}/* and */{0} trading pairs will be canceled. You can withdraw {0} to your private addresses till {1}",
            "de": "🇩🇪[DE]🚮  Das {0} wurde von 50x.com Exchange gelöscht. Alle Aufträge in den Handelspaaren {0} / * und * / {0} werden storniert. Sie können {0} Token an Ihre privaten Adressen abheben, bis {1}",
            "fr": "🇫🇷[FR] Le {0} a été décoté de la bourse 50x.com. Toutes les commandes utilisant les paires d’échange {0}/* et */{0} seront annulées. Vous pouvez retirer vos jetons {0} sur votre adresse privée jusqu'à {1}",
            "it": "🇮🇹[IT] Il {0} è stato rimosso dalla borsa 50x.com. Tutti gli ordini nelle coppie di trading {0}/ * e * /{0} verranno annullati. Puoi ritirare i gettoni {0} verso i tuoi indirizzi privati fino al {1}",
            "ja": "🇯🇵[JA] {0}トークンは50x.comの取引所から除外されています。{0}/* と */{0} の取引ペアの注文は全てキャンセルされます。{0}トークンは{1}までに、お使いのプライベートアドレスに引き出すことができます。",
            "ko": "🇰🇷[KO] {0} 토큰이 50x.com 거래소에서 삭제되었습니다. {0} / * 및 * / {0} 거래 쌍의 모든 주문이 취소됩니다. {1}까지 비공개 주소로 {0} 토큰을 인출 할 수 있습니다.",
            "tr": "🇹🇷[TR] {0} 50x.com exchange'den çıkarılmıştır. {0}/* ve */{0} işlem çiftlerindeki tüm komutlar iptal edilecektir. {1} tarihine kadar {0} tokenlerini özel adreslerinize çekebilirsiniz",
            "uk": "🇺🇦[UK] Проведено делістинг {0} на біржі. Всі ордера в парах {0}/* та */{0} будут автоматично відмінені. Виведення токенів {0} доступно до {1}.",
            "zh": "🇨🇳[ZH] {0}代币已从50x.com exchange中删除。{0}/*和*/{0}交易对中的所有订单都将被取消。您可以将{0}代币撤回到您的私人地址，直到{1}",
            "ru": "🇷🇺[RU] Проведен делистинг {0} на бирже. Все ордера в парах {0}/* и */{0} будут автоматически отменены. Вывод токенов {0} доступен до {1}."
        },
        "all_system_off": {
            "help": "НЕДОДЕЛАНО! {0}=start",
            "en": "🇬🇧[EN] Trades and withdrawals on 50x.com will be paused for maintenance from {0} for several hours.",
            "fr": "🇫🇷[FR] Les échanges et les prélèvements sur 50x.com seront mis en pause pendant quelques heures pour effectuer l'entretien à partir de {0}.",
            "it": "🇮🇹[IT] Le negoziazioni e i prelievi su 50x.com verranno messi in pausa per la manutenzione da {0} per diverse ore.",
            "ja": "50x.comでの取引と出金は、{0}から数時間、 メンテナンスのために一時停止となります。",
            "ru": "🇷🇺[RU]⛔🛠 Торги и выводы токенов на 50x.com будут приостановлены для технических работ c {0} на несколько часов.",
            "test": "торги and withdrawals on 50x.com will be paused for maintenance from {0} for several hours.",
            "tr": "50x.com adresinde alım satım ve para çekme işlemleri {0} saatinden itibaren bakım için birkaç saat boyunca duraklatılacaktır.",
            "uk": "Торгівля та виведення токенів на 50x.com будуть призупинені для технічного обслуговування з {0} на декілька годин.",
            "zh": "50x.com上的交易和取款将暂停几个小时，以便从{0}开始维护。"
        },
        "all_system_on": {
            "help": "НЕДОДЕЛАНО!",
            "en": "🇬🇧[EN] Maintenance is over, trades and withdrawals are available on 50x.com",
            "fr": "🇫🇷[FR] L'entretien est terminé, les échanges et les prélèvements sont maintenant disponibles sur 50x.com.",
            "it": "🇮🇹[IT] La manutenzione è terminata, le negoziazioni e i prelievi sono disponibili su 50x.com",
            "ja": "メンテナンスが終了しました。50x.comで取引と出金を行うことができます。",
            "ru": "Обслуживание завершено, торги и ввод/вывод доступны на 50x.com",
            "test": "Maintenance рпарпа, trades and withdrawals are available on 50x.com",
            "tr": "Bakım sonlandırıldı, 50x.com adresinde alım satım ve para çekme işlemleri kullanıma hazırdır",
            "uk": "Технічне обслуговування закінчено, торгівля та зарахування/виведення на 50x.com доступні",
            "zh": "维修结束，交易和取款可在50x.com上获得"
        },
        "all_symTrade_off": {
            "help": "{0}=symlist",
            "en": "🇬🇧[EN]⛔🛠️ {0} trades are paused for maintenance.",
            "fr": "🇫🇷[FR]⛔🛠️ Les échanges en {0} sont mises en pause pour effectuer l'entretien.",
            "de": "🇩🇪[DE]⛔🛠 {0} Trades werden zur Wartung angehalten.",
            "it": "🇮🇹[IT]⛔🛠️ Le operazioni {0} sono in pausa per manutenzione.",
            "ko": "🇰🇷[KO]⛔🛠️ 유지 보수를 위해 {0} 거래가 일시 중지되었습니다.",
            "ja": "🇯🇵[JA]⛔🛠️ {0}の取引はメンテナンスのために一時停止となります。",
            "ru": "🇷🇺[RU]⛔🛠 Торги {0} приостановлены для проведения техработ.",
            "tr": "🇹🇷[TR]⛔🛠️ {0} alım satım işlemleri bakım için duraklatıldı.",
            "uk": "🇺🇦[UK]⛔🛠 Торгівля {0} призупинено для обслуговування.",
            "zh": "🇨🇳[ZH]⛔🛠️ {0}交易暂停以进行维护。"
        },
        "all_blockchain_off": {
            "help": "{0}=blockchain, {1}=symlist",
            "en": "🇬🇧[EN] ⛔🛠️ {1} tokens' deposits and withdrawals on the {0} blockchain are paused for maintenance.",
            "de": "🇩🇪[DE] ⛔🛠️ Die Ein- und Auszahlungen von {1} Token in der {0} -Blockchain werden zur Wartung angehalten.",
            "fr": "🇫🇷[FR] ⛔🛠️ Le dépôt et le retrait des jetons {1} sur la blockchain {0} ont été suspendus pour maintenance.",
            "it": "🇮🇹[IT] ⛔🛠️ Il deposito e il ritiro dei token {1} sulla blockchain {0} è stato sospeso per manutenzione.",
            "ko": "🇰🇷[KO] ⛔🛠️ 유지 보수를 위해 {0} 블록 체인에서 {1} 토큰의 입출금이 일시 중지되었습니다.",
            "ja": "🇯🇵[JA] ⛔🛠️ {0}ブロックチェーンでの {1} トークンの入金と引き出しは、メンテナンスのために一時停止されています。",
            "zh": "🇨🇳[ZH] ⛔🛠️ {0}区块链上{1}代币的存取已被暂停维护。",
            "tr": "🇹🇷[TR] ⛔🛠️ {0} blok zincirinde {1} jetonlarının yatırılması ve çekilmesi, bakım için askıya alındı.",
            "uk": "🇺🇦[UK] ⛔🛠 Депозит і виведення токенів {1} на блокчейні {0} призупинено для обслуговування.",
            "ru": "🇷🇺[RU] ⛔🛠 Вводы и выводы токенов {1} на блокчейне {0} приостановлены для техобслуживания."
        },
        "all_blockchain_on": {
            "help": "{0}=blockchain, {1}=symlist",
            "en": "🇬🇧[EN] 🛠✅ {0} node maintenance is over, trades, deposits and withdrawals of the {1} are available on 50x.com",
            "de": "🇩🇪[DE] 🛠✅ Die {0} -Knotenwartung ist beendet, Trades, Ein- und Auszahlungen der {1} sind auf 50x.com verfügbar",
            "fr": "🇫🇷[FR] 🛠✅ La maintenance du nœud {0} est terminée, les transactions, les dépôts et les retraits de {1} sont disponibles sur 50x.com",
            "it": "🇮🇹[IT] 🛠✅ La manutenzione del nodo {0} è terminata, operazioni, depositi e prelievi di {1} sono disponibili su 50x.com",
            "ko": "🇰🇷[KO] 🛠✅ {0} 노드 유지 관리가 종료되었으며, {1}의 거래, 입금 및 인출이 50x.com에서 가능합니다.",
            "ja": "🇯🇵[JA] 🛠✅ {0}ノードのメンテナンスが終了し、 {1}の取引、入金、引き出しが50x.comで利用可能になりました",
            "zh": "🇨🇳[ZH] 🛠✅ {0}节点维护已结束，{1}的交易，存款和提款可在50x.com上获得",
            "tr": "🇹🇷[TR] 🛠✅ {0} düğümü bakımı bitti, {1} ile ilgili işlemler, para yatırma ve çekme işlemleri 50x.com'da mevcut",
            "uk": "🇺🇦[UK] 🛠✅ Обслуговування вузла {0} закінчено, торгівлі, депозити та зняття коштів із {1} доступні на 50x.com",
            "ru": "🇷🇺[RU] 🛠✅ Обслуживание ноды {0} завершено, торги и ввод/вывод {1} доступны на 50x.com"
        },
        "login_success": {
            "en": "Successful login to {username} from IP {ip}.",
            "ru": "Вход в аккаунт {username} с IP {ip}."
        },
        "logout_all": {
            "en": "You logged out from all your connected devices.",
            "ru": "Выход со всех устройств"
        },
        "incomingtransaction": {
            "en": "New incoming transaction.",
            "ru": "Новая входящая транзакция."
        },
        "withdrawaltransaction": {
            "en": "New withdrawal transaction.",
            "ru": "Новый вывод токенов."
        },
        "trades": {
            "en": "Trade executed in the {sym1}/{sym2} {buy_sell} order {id}.",
            "ru": "Проведена сделка в {sym1}/{sym2} ордер {buy_sell} {id}."
        },
        "orderfulfilment": {
            "en": "{sym1}/{sym2} {buy_sell} order {id} has been fulfilled.",
            "ru": "{sym1}/{sym2} ордер {buy_sell} {id} исполнен полностью."
        },
        "SLTPfilled": {
            "en": "SLTP {sym1}/{sym2} {buy_sell} order {id} has been fulfilled. Your profit is {profit} {sym2} ({profitPCT}%)",
            "ru": "SLTP ордер {buy_sell} {sym1}/{sym2} №{id} исполнен. Получена прибыль {profit} {sym2} ({profitPCT}%)"
        },
        "dailyreport": {
            "en": "TODO"
        },
        "password_change_request": {
            "en": "Password changing request has been received.\nIf it wasn't you, report to support@50x.com immediately!",
            "ru": "Получен запрос на смену пароля.\nЕсли его отправили не вы, немедленно свяжитесь с support@50x.com"
        },
        "password_change": {
            "en": "Password has been changed on your account.",
            "ru": "Пароль был заменен на вашем аккаунте."
        },
        "enable_otp": {
            "en": "2-Factor Authentication (OTP) has been enabled on your account.",
            "ru": "На вашем аккаунте активированы однократные коды двухфакторной аутентификации (OTP)."
        },
        "otp_change": {
            "en": "Main 2-Factor Authentication (OTP) Private Key has been changed on your account.",
            "ru": "На вашем аккаунте ИЗМЕНЕНЫ однократные коды двухфакторной аутентификации (OTP)."
        },
        "enable_otp_wd": {
            "en": "Additional withdrawal codes of the 2-Factor Authentication (WOTP) have been enabled on your account.",
            "ru": "На вашем аккаунте активированы ДОПОЛНИТЕЛЬНЫЕ однократные коды двухфакторной аутентификации на вывод токенов (WOTP)."
        },
        "disable_otp_wd": {
            "en": "Additional withdrawal codes of the 2-Factor Authentication (WOTP) have been disabled on your account.",
            "ru": "На вашем аккаунте отключены Дополнительные Однократные Коды двухфакторной аутентификации на вывод токенов (WOTP)."
        },
        "fail_otp": {
            "en": "Wrong 2FA OTP has been used on your account. Request was rejected.",
            "ru": "Неверный однократный код двухфакторной аутентификации (OTP) был использован на вашем аккаунте. Запрос отклонен."
        },
        "set_masterkey": {
            "en": "Master Key has been set on your account.",
            "ru": "Мастер ключ был установлен на вашем аккаунте."
        },
        "set_main": {
            "en": "Main Telegram ID has been changed to {telegram_id}.",
            "ru": "Ваш основной Telegram ID был изменен на {telegram_id}."
        },
        "withdrawal_delay_change": {
            "en": "Withdrawal delay has been changed.",
            "ru": "Изменен срок задержки транзакций вывода."
        },
        "terminate_account": {
            "en": "Your account termination request has been received. This is the last message.",
            "ru": "Получен запрос на закрытие вашего аккаунта. Это последнее сообщение."
        },
        "terminate_telegram": {
            "en": "This Telegram account has been disconnected from your 50x.com trading account by your request. This is the last message.",
            "ru": "Данный аккаунт Telegram был отключен от вашего торгового аккаунта 50x.com. Это последнее сообщение."
        },
        "email_change": {
            "en": "Email has been changed on your account.",
            "ru": "Email был изменен на вашем аккаунте."
        },
        "place_order": {
            "en": "New {sym1}/{sym2} {buy_sell} {sltp} order {id} has been placed.",
            "ru": "Выставлен новый {sym1}/{sym2} {sltp} ордер {buy_sell} {id}."
        },
        "pack_disabled": {
            "en": "The following telegram notifications have been disabled on your account {name}",
            "ru": "На вашем аккаунте были отключены следующие уведомления в телеграм: {name}"
        },
        "change_order": {
            "en": "{sym1}/{sym2} {buy_sell} {sltp} order {id} has been changed:",
            "ru": "{sym1}/{sym2} {sltp} ордер {buy_sell} {id} был изменен:"
        },
        "cancel_order": {
            "en": "{sym1}/{sym2} ({buy_sell}) {sltp} order {id} has been cancelled.",
            "ru": "{sym1}/{sym2} {sltp} ордер {buy_sell} {id} был отменен."
        },
        "cancel_many_orders": {
            "en": "Order mass-cancellation request has been processed.",
            "ru": "Выполнен запрос массовой отмены ордеров."
        }
    },
    "blockchains": {
        "INTERNAL": {
            "en": "INTERNAL"
        },
        "BCH": {
            "en": "BITCOIN CASH",
            "fr": "BITCOIN CASH",
            "it": "BITCOIN CASH",
            "ja": "ビットコインキャッシュ",
            "tr": "BITCOIN CASH",
            "uk": "BITCOIN CASH",
            "zh": "比特币现金"
        },
        "BSC": {
            "en": "Binance SMART CHAIN (BEP20)",
            "ru": "Binance SMART CHAIN (BEP20)"
        },
        "BSV": {
            "en": "BITCOIN SV",
            "fr": "BITCOIN SV",
            "it": "BITCOIN SV",
            "ja": "ビットコインSV",
            "tr": "BITCOIN SV",
            "uk": "BITCOIN SV",
            "zh": "比特币SV"
        },
        "BTC": {
            "en": "BITCOIN",
            "fr": "BITCOIN",
            "it": "BITCOIN",
            "ja": "ビットコイン",
            "tr": "BITCOIN",
            "uk": "BITCOIN",
            "zh": "比特币"
        },
        "BTG": {
            "en": "BITCOIN GOLD",
            "fr": "BITCOIN GOLD",
            "it": "BITCOIN GOLD",
            "ja": "ビットコインゴールド",
            "tr": "BITCOIN GOLD",
            "uk": "BITCOIN GOLD",
            "zh": "比特币黄金"
        },
        "CARDANO": {
            "en": "CARDANO"
        },
        "DASH": {
            "en": "DASH",
            "fr": "DASH",
            "it": "DASH",
            "ja": "ダッシュ",
            "tr": "DASH",
            "uk": "DASH",
            "zh": "破折号"
        },
        "DGB": {
            "en": "DIGIBYTE",
            "fr": "DIGIBYTE",
            "it": "DIGIBYTE",
            "ja": "ディジバイト",
            "tr": "DIGIBYTE",
            "uk": "DIGIBYTE",
            "zh": "双字节"
        },
        "DOGE": {
            "en": "DOGECOIN",
            "fr": "DOGECOIN",
            "it": "DOGECOIN",
            "ja": "ドージコイン",
            "tr": "DOGECOIN",
            "uk": "DOGECOIN",
            "zh": "狗狗币"
        },
        "ETC": {
            "en": "ETHEREUM CLASSIC",
            "fr": "ETHEREUM CLASSIC",
            "it": "ETHEREUM CLASSIC",
            "ja": "イーサリアムクラシック",
            "tr": "ETHEREUM CLASSIC",
            "uk": "ETHEREUM CLASSIC",
            "zh": "以太坊经典"
        },
        "ETH": {
            "en": "ETHEREUM",
            "fr": "ETHEREUM",
            "it": "ETHEREUM",
            "ja": "イーサリアム",
            "tr": "ETHEREUM",
            "uk": "ETHEREUM",
            "zh": "以太坊"
        },
        "LTC": {
            "en": "LITECOIN",
            "fr": "LITECOIN",
            "it": "LITECOIN",
            "ja": "ライトコイン",
            "tr": "LITECOIN",
            "uk": "LITECOIN",
            "zh": "莱特币"
        },
        "MFC": {
            "en": "Mr. Freeman"
        },
        "NEM": {
            "en": "NEM"
        },
        "PZM": {
            "en": "PRIZM"
        },
        "POLKADOT": {
            "en": "Polkadot"
        },
        "QTUM": {
            "en": "QTUM",
            "fr": "QTUM",
            "it": "QTUM",
            "ja": "クアンタム",
            "tr": "QTUM",
            "uk": "QTUM",
            "zh": "量子链币"
        },
        "TON": {
            "en": "TON"
        },
        "TEZOS": {
            "en": "TEZOS"
        },
        "YODAX": {
            "en": "YodaX"
        },
        "TRX": {
            "en": "TRON",
            "fr": "TRON",
            "it": "TRON",
            "ja": "トロン",
            "tr": "TRON",
            "uk": "TRON",
            "zh": "实时操作系统内核"
        },
        "WAVES": {
            "en": "WAVES",
            "fr": "WAVES",
            "it": "WAVES",
            "ja": "ウェーブス",
            "tr": "WAVES",
            "uk": "WAVES",
            "zh": "波浪"
        },
        "XLM": {
            "en": "Stellar"
        },
        "XMR": {
            "en": "Monero"
        },
        "XRP": {
            "en": "RIPPLE",
            "fr": "RIPPLE",
            "it": "RIPPLE",
            "ja": "リップル",
            "tr": "RIPPLE",
            "uk": "RIPPLE",
            "zh": "涟漪"
        },
        "ZEC": {
            "en": "Zcash"
        },
        "ZHCASH": {
            "en": "ZHCASH"
        }
    },
	"common":{
		"customizable": {
			"en": "Customizable",
			"ru": "Настраиваемый"
		},
		"notifications": {
            "en": "Notifications",
            "ru": "Уведомления"
        },
		"notification": {
            "en": "Notification",
            "ru": "Уведомление"
        },
		"exportToCSV": {
            "en": "Export to CSV",
            "ru": "Экспортировать в CSV"
        },
        "addToHomeScreen": {
            "en": "Add to Home Screen",
            "de": "Zum Startbildschirm hinzufügen",
            "fr": "Ajouter à l'écran d'accueil",
            "it": "Aggiungere alla schermata Home",
            "ja": "ホーム画面に追加します",
            "ko": "홈 화면에 추가",
            "ru": "Добавить на основной экран",
            "tr": "Ana ekrana ekle",
            "uk": "Додати на головний екран",
            "zh": "添加到主屏幕"
        },
        "lastMonth": {
            "en": "Last Month",
            "de": "Letzte 30 Tage",
            "fr": "Les 30 derniers jours",
            "it": "Ultimi 30 giorni",
            "ja": "過去30日間",
            "ko": "지난 30일",
            "ru": "За последний месяц",
            "tr": "Geçen ay için",
            "uk": "За останній місяць",
            "zh": "过去 30 天"
        },
        "subaccount": {
            "en": "Subaccount",
            "de": "Unterkonto",
            "fr": "Sous-compte",
            "it": "Account secondario",
            "ja": "サブアカウント",
            "ko": "하위 계정",
            "ru": "Субсчет",
            "tr": "Alt hesap",
            "uk": "Субрахунок",
            "zh": "子帐户"
        },
        "systemstatus": {
            "en": "System Status",
            "de": "Systemstatus",
            "fr": "État du système",
            "it": "Stato del sistema",
            "ja": "システムステータス",
            "ko": "시스템 상태",
            "ru": "Статус системы",
            "tr": "Sistem durumu",
            "uk": "Статус системи",
            "zh": "系统状态"
        },
		"flexible": {
            "en": "Flexible",
            "de": "Souple",
            "fr": "Flexibel",
            "it": "Flessibile",
            "ja": "フレキシブル",
            "ko": "유연한",
            "ru": "Гибкий",
            "tr": "Esnek",
            "uk": "Гнучкий",
            "zh": "灵活的"
        },
		"fixed": {
            "en": "Fixed",
            "de": "Statisch",
            "fr": "Statique",
            "it": "Statico",
            "ja": "静的",
            "ko": "공전",
            "ru": "Фиксированный",
            "tr": "Statik",
            "uk": "Статичний",
            "zh": "静止的"
        },
		"copyLink": {
            "en": "Copy link",
            "de": "Link kopieren",
            "fr": "Copier le lien",
            "it": "Copia link",
            "ja": "リンクをコピーする",
            "ko": "링크 복사",
            "ru": "Копировать ссылку",
            "tr": "Bağlantıyı kopyala",
            "uk": "Копіювати посилання",
            "zh": "复制链接"
        },
		"vip": {
            "en": "VIP"
        },
        "payableA2A": {
            "en": "A2A amount available for the fee payment",
            "de": "Verfügbarer A2A-Betrag für die Gebührenzahlung",
            "fr": "Montant A2A disponible pour le paiement des frais",
            "it": "Importo A2A disponibile per il pagamento del canone",
            "ja": "手数料の支払いに利用できるA2Aの金額",
            "ko": "A2A 수수료 결제 가능 금액",
            "ru": "Сумма A2A, доступная для оплаты комиссии",
            "tr": "Ücret ödemesi için kullanılabilir A2A miktarı",
            "uk": "Сума A2A доступна для сплати збору",
            "zh": "可用于支付费用的 A2A 金额"
        },
        "transactions": {
            "en": "Transactions",
            "de": "Transaktionen",
            "fr": "Transactions",
            "it": "Le transazioni",
            "ja": "トランザクション",
            "ko": "거래",
            "ru": "Транзакции",
            "tr": "İşlemler",
            "uk": "Транзакції",
            "zh": "交易"
        },
        "incomingTransactions": {
            "en": "Incoming transactions",
            "de": "Eingehende Transaktionen",
            "fr": "Transactions entrantes",
            "it": "Transazioni in entrata",
            "ja": "トランザクションの受信",
            "ko": "수신중인 트랜잭션",
            "ru": "Входящие транзакции",
            "tr": "Gelen işlemler",
            "uk": "Вхідні транзакції",
            "zh": "收入交易"
        },
        "withdrawalTransactions": {
            "en": "Withdrawal transactions",
            "de": "Auszahlungstransaktionen",
            "fr": "Opérations de retrait",
            "it": "Transazioni di prelievo",
            "ja": "出金トランザクション",
            "ko": "거래 철회",
            "ru": "Исходящие транзакции",
            "tr": "Para çekme işlemleri",
            "uk": "Вихідні транзакції",
            "zh": "提款交易"
        },
        "accountInfo": {
            "en": "Account info",
            "de": "Kontoinformation",
            "fr": "Informations de compte",
            "it": "Informazioni sull'account",
            "ja": "アカウント情報",
            "ko": "계정 정보",
            "ru": "Информация об аккаунте",
            "tr": "Hesap bilgisi",
            "uk": "Інформація про рахунок",
            "zh": "帐户信息"
        },
        "account": {
            "en": "Account",
            "de": "Konto",
            "fr": "Compte",
            "it": "Account",
            "ja": "アカウント",
            "ko": "계정",
            "ru": "Аккаунт",
            "tr": "Hesap",
            "uk": "Рахунок",
            "zh": "帐户"
        },

        "emailConfirmation": {
            "en": "Email confirmation",
            "de": "Email Bestätigung",
            "fr": "Confirmation de l'émail",
            "it": "Conferma via email",
            "ja": "メールアドレスの確認",
            "ko": "이메일 확인",
            "ru": "Подтверждение email",
            "tr": "E-posta onayı",
            "uk": "Підтвердження email",
            "zh": "电子邮件确认"
        },
        "currenciesInfo": {
            "en": "Currencies info",
            "de": "Währungsinfos",
            "fr": "Informations sur les devises",
            "it": "Informazioni sulle valute",
            "ja": "通貨情報",
            "ko": "통화 정보",
            "ru": "Информация о монетах",
            "tr": "Para birimleri bilgisi",
            "uk": "Інформація про монети",
            "zh": "货币信息"
        },
        "estimatedBalance": {
            "en": "Estimated Balance",
            "de": "Geschätzter Saldo",
            "fr": "Solde estimé",
            "it": "Saldo stimato",
            "ja": "予測される残高",
            "ko": "예상 잔액",
            "ru": "Балансов на",
            "tr": "Tahmini Bakiye",
            "uk": "Балансів на",
            "zh": "预计余额"
        },
        "theme": {
            "en": "Theme",
            "de": "Thema",
            "fr": "Thème",
            "it": "Tema",
            "ja": "テーマ",
            "ko": "주제",
            "ru": "Тема",
            "tr": "Tema",
            "uk": "Тема",
            "zh": "主题"
        },
        "themedark": {
            "en": "Dark",
            "de": "Dunkel",
            "fr": "Foncé",
            "it": "Scuro",
            "ja": "ダーク",
            "ko": "어두운",
            "ru": "Темная",
            "tr": "Koyu",
            "uk": "Темна",
            "zh": "黑色"
        },
        "themelight": {
            "en": "Light",
            "de": "Licht",
            "fr": "Clair",
            "it": "Chiaro",
            "ja": "ライト",
            "ko": "빛",
            "ru": "Светлая",
            "tr": "Açık",
            "uk": "Світла",
            "zh": "明亮的"
        },
        "lang_label": {
            "en": "Language",
            "de": "Sprache",
            "fr": "Langue",
            "it": "Lingua",
            "ja": "言語",
            "ko": "언어",
            "ru": "Язык",
            "tr": "Dilim",
            "uk": "Мова",
            "zh": "语"
        },
        "contractAddress": {
            "en": "Contract address",
            "de": "Vertragsadresse",
            "fr": "Adresse de contrat",
            "it": "Indirizzo del contratto",
            "ja": "コントラクトアドレス",
            "ko": "계약 주소",
            "ru": "Адрес контракта",
            "tr": "Sözleşme adresi",
            "uk": "Адреса контракту",
            "zh": "合同地址"
        },
        "connection": {
            "en": "Сonnection",
            "de": "Verbindung",
            "fr": "Connexion",
            "it": "Connessione",
            "ja": "接続",
            "ko": "연결",
            "ru": "Соединение",
            "tr": "Bağlantı",
            "uk": "З'єднання",
            "zh": "连接"
        },
        "websocketConnection": {
            "en": "Websocket connection",
            "de": "Websocket-Verbindung",
            "fr": "Connexion Websocket",
            "it": "Connessione WebSocket",
            "ja": "ウェブソケットの接続",
            "ko": "웹 소켓 연결",
            "ru": "Соединение с Websocket",
            "tr": "Web soketi bağlantısı",
            "uk": "З'єднання з Websocket",
            "zh": "双向通信连接"
        },
        "wallets": {
            "en": "Wallets",
            "de": "Geldbörsen",
            "fr": "Portefeuilles",
            "it": "Portafogli",
            "ja": "ウォレット",
            "ko": "지갑",
            "ru": "Кошельки",
            "tr": "Cüzdanlar",
            "uk": "Гаманці",
            "zh": "钱包"
        },
        "hideSmallBalances": {
            "en": "Hide small balances",
            "de": "Kleine Guthaben ausblenden",
            "fr": "Masquer les petits soldes",
            "it": "Nascondi piccoli saldi",
            "ja": "小さな残高を隠す",
            "ko": "작은 잔액 숨기기",
            "ru": "Спрятать мелкие балансы",
            "tr": "Küçük bakiyeleri gizle",
            "uk": "Сховати невеликі баланси",
            "zh": "隐藏小余额"
        },
        "empty_key": {
            "en": "",
            "de": "",
            "fr": "",
            "it": "",
            "ja": "",
            "ko": "",
            "ru": "",
            "tr": "",
            "uk": "",
            "zh": ""
        },
        "button_reload": {
            "en": "Update",
            "de": "Aktualisieren",
            "fr": "Mettre à jour",
            "it": "Aggiornare",
            "ja": "更新",
            "ko": "새롭게 하다",
            "ru": "Обновить",
            "tr": "Güncelleştirmek",
            "uk": "Перезавантажте",
            "zh": "重装"
        },
        "button_closeAsFulfilled": {
            "en": "Close as fulfilled",
            "de": "Schließen Sie wie erfüllt",
            "fr": "Fermer comme rempli",
            "it": "Chiudi come soddisfatto",
            "ja": "満たされたように閉じる",
            "ko": "완료 됨으로 종료",
            "ru": "Закрыть как исполненный",
            "tr": "Tamamlandığı gibi kapat",
            "uk": "Закрити як виконане",
            "zh": "圆满完成"
        },
        "paymentSystem": {
            "en": "Payment system",
            "de": "Bezahlsystem",
            "fr": "Système de paiement",
            "it": "Sistema di pagamento",
            "ja": "支払いシステム",
            "ko": "결제 시스템",
            "ru": "Платежная система",
            "tr": "Ödeme sistemi",
            "uk": "Платіжна система",
            "zh": "支付系统"
        },
        "button_payCard": {
            "en": "Buy {sym} with Visa / E-money",
            "fr": "Achetez {sym} avec Visa / E-money",
            "de": "Kauf {sym} über Visa / E-Geld",
            "it": "Acquista {sym} con Visa / moneta elettronica",
            "ja": "Visa / E-moneyで{sym}を購入する",
            "ko": "Visa / e-money를 통해 {sym} 구매",
            "ru": "Купить {sym} с карты",
            "tr": "Visa / E-money ile {sym} satın alın",
            "uk": "Купуйте {sym} за допомогою Visa / E-money",
            "zh": "通过Visa /电子货币购买{sym}"
        },
        "limitsDisabled": {
            "en": "Attention! Currently some system limits are disabled to let you to try the system with small amount of tokens and provide a feedback to the developers.",
            "fr": "Attention! Actuellement, certaines limites du système sont désactivées pour vous permettre d'essayer le système avec une petite quantité de jetons et de fournir une rétroaction aux développeurs.",
            "it": "Attenzione! Attualmente alcuni limiti di sistema sono disabilitati per consentire di provare il sistema con una piccola quantità di token e fornire un feedback agli sviluppatori.",
            "ja": "注意！ 現在、少量のトークンでシステムを試して、開発者にフィードバックを提供できるように、いくつかのシステム制限が無効になっています。",
            "ru": "ВНИМАНИЕ! Некоторые лимиты в настоящее время выключены, чтобы вы могли опробовать систему на минимальных средствах и дали свой отзыв по юзабилити интерфейса.",
            "tr": "Dikkat! Şu anda, az miktarda tokenle sistemi denemenize ve geliştiricilere geri bildirimde bulunmanıza izin vermek için bazı sistem limitleri devre dışı bırakılmıştır.",
            "uk": "УВАГА! Деякі ліміти в даний час виключені, щоб ви могли випробувати систему на мінімальних засобах і дали свій відгук по юзабіліті інтерфейсу.",
            "zh": "注意！目前，一些系统限制被禁用，允许您尝试使用少量代币的系统，并向开发人员提供反馈。"
        },
        "yesNo": {
            "0": {
				"en": "No",
				"de": "Nein",
				"fr": "Non",
				"it": "No",
				"ja": "いいえ",
				"ko": "아니",
				"ru": "Нет",
				"tr": "Hayir",
				"uk": "Ні",
				"zh": "不"
            },
            "1": {
                "en": "Yes",
				"de": "Ja",
				"fr": "Oui",
				"it": "sì",
				"ja": "はい",
				"ko": "예",
                "ru": "Да",
				"tr": "Evet",
				"uk": "Так",
				"zh": "是的"
            }
		},
        "used": {
            "en": "Used",
            "ru": "Использовано"
        },
        "current": {
            "en": "Current",
            "ru": "Текущее"
        },
        "limit_TH": {
            "en": "Limit",
            "ru": "Лимит"
        },
        "income": {
            "en": "Income",
            "fr": "Revenu",
            "it": "Guadagni",
            "ja": "収益",
            "ru": "Прибыль",
            "tr": "Gelir",
            "uk": "Прибуток",
            "zh": "收入"
        },
        "actions": {
            "en": "Actions",
            "fr": "Actions",
            "it": "Azioni",
            "ja": "操作",
            "ko": "액션",
            "ru": "Действия",
            "tr": "Eylemler",
            "uk": "Дії",
            "zh": "行动"
        },
        "age": {
            "en": "Age",
            "fr": "Âge",
            "it": "Età",
            "ja": "経過時間",
            "ko": "기간",
            "ru": "Возраст",
            "tr": "Yaş",
            "uk": "Вік",
            "zh": "年龄"
        },
        "wpLink50x": {
            "en": "https://go.50x.com/media/pdf/wp-50x-en.pdf"
        },
        "wpLink50x100": {
            "en": "https://go.50x.com/media/pdf/wp-50x100-en.pdf",
            "ru": "https://go.50x.com/media/pdf/wp-50x100-ru.pdf",
            "uk": "https://go.50x.com/media/pdf/wp-50x100-ru.pdf"
        },
        "promo": {
            "en": "Promo code",
            "fr": "Code Promo",
            "it": "Codice promozionale",
            "ja": "プロモコード",
            "ru": "Промокод",
            "tr": "Promosyon kodu",
            "uk": "Промокод",
            "zh": "促销代码"
        },
        "promo_placeholder": {
            "en": "Can be left blank",
            "fr": "Peut laisser vide",
            "it": "Puoi lasciarlo vuoto",
            "ja": "空欄にすることができます。",
            "ru": "Можно не заполнять",
            "tr": "Boş bırakılabilir",
            "uk": "Можна не заповнювати",
            "zh": "可以留空"
        },
		"pack": {
			"en": "Pack",
			"ru": "Пак"
		},
		"referralLink": {
			"en": "Referral link",
			"ru": "Партнерская ссылка"
		},
		"button_showExecutionGraph": {
			"en": "Show Execution Graph",
			"ru": "Показать граф исполнения"
		},
		"button_copyAddress": {
			"en": "Copy address", 
			"fr": "Copier l'adresse", 
			"it": "Copia indirizzo", 
			"ja": "アドレスをコピーする", 
			"ru": "Копировать адрес", 
			"tr": "Adresi kopyala", 
			"uk": "Копіювати адресу", 
			"zh": "复制地址"
		},
		"login": {
			"en": "Login",
			"ru": "Логин"
		},
		"incomingTransaction": {
		  "en": "Incoming transaction",
		  "fr": "Transaction entrante",
		  "it": "Transazione in entrata",
		  "ja": "受信したトランザクション",
		  "ru": "Входящая транзакция",
		  "tr": "Gelen işlem",
		  "uk": "Вхідна транзакція",
		  "zh": "传入事务"
		},
		"withdrawalTransaction": {
		  "en": "Withdrawal transaction",
		  "fr": "Opération de retrait",
		  "it": "Transazione di prelievo",
		  "ja": "出金トランザクション",
		  "ru": "Исходящая транзакция",
		  "tr": "Para çekme işlemi",
		  "uk": "Вихідна транзакція",
		  "zh": "提款交易"
		},
        "telegramID": {
            "en": "Telegram ID",
            "ru": "ID в Telegram"
        },
        "makeMain": {
            "en": "Make MAIN",
            "ru": "Сделать ОСНОВНЫМ"
        },
        "main": {
            "en": "MAIN",
            "ru": "ОСНОВНОЙ"
        },
        "orderActions": {
            "en": "Order actions",
            "ru": "Действия с ордерами"
        },
        "orderActions_description": {
            "en": "A notification will be sent for any user actions with trading orders: placement, changes, cancelation. This pack us useful if your account is under third-party management, or if you are using trading bot via API",
            "ru": "Извещение будет отправлено при любом действии пользователя с ордерами (создание, изменение, отмена). Этот пак имеет смысл использовать если ваш аккаунт находится под внешним управлением, например если вы используете торгового бота через API."
        },
        "orderFulfilment": {
            "en": "Order fulfilment",
            "ru": "Исполнение ордера"
        },
        "orderFulfilment_description": {
            "en": "You will receive a notification for each fully filled order upon fulfilment.",
            "ru": "Вы получите извещение о полном исполнении ордера как только он будет исполнен полностью."
        },
        "trades": {
            "en": "Trades",
            "ru": "Сделки"
        },
        "tradesPack": {
            "en": "Trades",
            "ru": "Сделки"
        },
        "tradesPack_description": {
            "en": "Trades pack includes each separate trade information, combined in 5 minutes sets. [common.orderFulfilment] Pack should be enough for most traders, keep in mind that Trades Pack can generate many notifications for each separate order.",
            "ru": "Сделки - будет отправляться сообщение о всех отдельных сделках обмена на вашем аккаунте, сгруппированных в пределах 5 минут, и таких сообщений может быть много в процессе исполнения отдельного ордера. Большинству трейдеров будет достаточно подписки на [common.orderFulfilment]. "
        },
        "_free": {
            "en": "(free of charge)",
            "ru": "(бесплатно)"
        },
        "securityPack": {
            "en": "Security Pack",
            "ru": "Пакет Безопасности"
        },
        "securityPack_description": {
            "en": "Security Pack includes notifications about the following actions:<br><br>Main Telegram account changed<br>Notification subscription cancellation<br>Successful login<br>Wrong 2FA OTP used<br>Password changing request / Password changed<br>Withdrawal delay changed<br>New withdrawal request (if withdrawal delay is set)<br>Account termination<br>Account termination request using login<br>WOTP activation / deactivation<br>E-mail changed",
            "ru": "Пакет Безопасности включает в себя уведомления о следующих действиях:<br>Изменение главного телеграм аккаунта<br>Удаление телеграм-подписок<br>Успешный вход в аккаунт<br>Ввод неверного однократного пароля двухфакторной аутентификации (OTP)<br>Запрос смены пароля / Смена пароля<br>Изменение срока задержки исходящих транзакций<br>Создание ордера на вывод средств (если стоит задержка вывода)<br>Удаление аккаунта мастер-ключом<br>Запрос на удаление аккаунта по логину<br>Включение/отключение дополнительного однократного пароля (WOTP)<br>Смена e-mail"
        },
        "dailyReport": {
            "en": "Daily report",
            "ru": "Ежедневный отчет"
        },
        "dailyReport_description": {
            "en": "Daily report includes wallet balances and token transaction info for the last 24 hours.",
            "ru": "Ежедневный отчет содержит данные о балансах кошельков и движениях по счету за последние 24 часа."
        },
        "id": {
            "en": "Identifier", 
            "fr": "Identifier", 
            "it": "Identificatore", 
            "ja": "識別子", 
            "ru": "Идентификатор", 
            "tr": "Belirteç", 
            "uk": "Ідентифікатор", 
            "zh": "标识符"
        }, 
        "id_TH": {
            "en": "ID", 
            "fr": "ID", 
            "it": "ID", 
            "ja": "ID", 
            "ru": "ID", 
            "tr": "Kimlik", 
            "uk": "ID", 
            "zh": "身份证件"
        },
        "date": {
            "en": "Date", 
            "fr": "Date", 
            "it": "Data", 
            "ja": "日付", 
            "ru": "Дата", 
            "tr": "Tarih", 
            "uk": "Дата", 
            "zh": "日期"
        },
        "type": {
            "en": "Type",
            "fr": "Type",
            "it": "Tipo",
            "ja": "種類",
            "ko": "유형",
            "ru": "Тип",
            "tr": "Tür",
            "uk": "Тип",
            "zh": "类型"
        },
        "action": {
            "en": "Action", 
            "fr": "Action", 
            "it": "Azione", 
            "ja": "アクション", 
            "ru": "Событие", 
            "tr": "Aksiyon", 
            "uk": "Подія", 
            "zh": "行动"
        },
		"change": {
			"en": "Change", 
			"fr": "Modifier", 
			"it": "Cambia", 
			"ja": "変化", 
			"ko": "변경", 
			"ru": "Изменение", 
			"tr": "Değişiklik", 
			"uk": "Зміна", 
			"zh": "改变"
		},
        "balance": {
            "en": "Balance",
            "ru": "На счету"
        },
        "username": {
            "en": "Username",
            "ru": "Имя пользователя"
        },
        "newEmail": {
            "en": "New E-mail",
            "ru": "Новый E-mail"
        },
        "ip": {
            "en": "IP",
            "exclude": "TRUE"
        },
        "filledVolume": {
            "en": "Filled volume", 
            "fr": "Volume rempli", 
            "it": "Volume eseguito", 
            "ja": "入力済みの数量", 
            "ko": "채워진 수량", 
            "ru": "Исполненное количество", 
            "tr": "Doldurulmuş işlem hacmi", 
            "uk": "Виконана кількість", 
            "zh": "填充体积"
        }, 
        "filltotal": {
            "en": "Total fill", 
            "fr": "Remplissage total", 
            "it": "Esecuzione totale", 
            "ja": "入力合計", 
            "ko": "전체 채워짐", 
            "ru": "Исполнено на сумму", 
            "tr": "Toplam doldurma", 
            "uk": "Виконано на суму", 
            "zh": "总填充"
        },
		"info": {
			"en": "Info",
			"fr": "Information",
			"it": "Info",
			"ja": "情報",
			"ru": "Подробнее",
			"tr": "Bilgi",
			"uk": "Детальніше",
			"zh": "信息"
		},
        "withdrawalDelayNewFrom": {
            "en": "New withdrawal delay ({withdrawal_delay} hours) will be activated from {dateTime}", 
            "fr": "Le nouveau délai de prélèvement ({withdrawal_delay} heures) sera activé à partir de {dateTime}", 
            "it": "Il nuovo ritardo di prelievo ({withdrawal_delay} ore) verrà attivato da {dateTime}", 
            "ja": "新しい出金遅延（{withdrawal_delay}）は{dateTime}から有効になります。", 
            "ru": "Новая задержка вывода средств ({withdrawal_delay} часов) будет действовать с {dateTime}", 
            "tr": "{dateTime} tarihinden itibaren yeni para çekme işleminde erteleme ({withdrawal_delay} saat) etkinleştirilecektir", 
            "uk": "Нова затримка виведення коштів ({withdrawal_delay} годин) буде діяти з {dateTime}", 
            "zh": "将从{dateTime}激活新的取款延迟({withdrawal_delay} hours)"
        }, 
        "withdrawalDelayNew": {
            "en": "New withdrawal delay: {withdrawal_delay} hours", 
            "fr": "Nouveau délai de prélèvement : {withdrawal_delay} heures", 
            "it": "Nuovo ritardo di prelievo: {withdrawal_delay} ore", 
            "ja": "新しい出金遅延：{withdrawal_delay}時間", 
            "ru": "Новая задержка вывода средств: {withdrawal_delay} часов", 
            "tr": "Yeni para çekme işleminde erteleme: {withdrawal_delay} saat", 
            "uk": "Нова затримка виведення коштів {withdrawal_delay} годин", 
            "zh": "新取款延迟：{withdrawal_delay}小时"
        }, 
        "withdrawalDelay_description": {
            "en": "Min {domain.withdrawalDelayMin} max {domain.withdrawalDelayMax} hours", 
            "fr": "Min {domain.withdrawalDelayMin} max {domain.withdrawalDelayMax} heures", 
            "it": "Min {domain.withdrawalDelayMin} max {domain.withdrawalDelayMax} ore", 
            "ja": "最小{domain.withdrawalDelayMin}〜最大{domain.withdrawalDelayMax}時間", 
            "ru": "Можно задать от {domain.withdrawalDelayMin} до {domain.withdrawalDelayMax} часов", 
            "tr": "Minimum {domain.withdrawalDelayMin} maksimum {domain.withdrawalDelayMax} saat", 
            "uk": "Можна задати від {domain.withdrawalDelayMin} кілька разів {domain.withdrawalDelayMax} годин", 
            "zh": "最小 {domain.withdrawalDelayMin}最大{domain.withdrawalDelayMax}小时"
        }, 
        "withdrawalDelay": {
            "en": "Current withdrawal delay: {withdrawal_delay} hours", 
            "fr": "Délai de prélèvement actuel: {withdrawal_delay} heures", 
            "it": "Ritardo di prelievo attuale: {withdrawal_delay} ore", 
            "ja": "現在の出金遅延：{withdrawal_delay}時間", 
            "ru": "Задержка вывода средств: {withdrawal_delay} часов", 
            "tr": "Mevcut para çekme ertelemesi: {withdrawal_delay} saat", 
            "uk": "Затримка виведення коштів: {withdrawal_delay} годин", 
            "zh": "当前取款延迟：{withdrawal_delay}小时"
        }, 
        "withdrawalDelayed": {
            "en": "This transaction is delayed and will be executed after {time_payout_after} because you activated a delay for withdrawals. You may change or cancel this delay in the SETTINGS section.", 
            "fr": "Cette transaction est retardée et sera exécutée après {time_payout_after} car vous avez activé un retard pour les retraits. Vous pouvez modifier ou annuler ce délai dans la section PARAMÈTRES.", 
            "it": "Questa transazione è ritardata e verrà eseguita dopo {time_payout_after} perché hai attivato un ritardo per i prelievi. È possibile modificare o annullare questo ritardo nella sezione IMPOSTAZIONI.", 
            "ja": "このトランザクションは遅延されており、{time_payout_after}後に実行されます。これは、引き出しの遅延を有効にしたためです。設定セクションでこの遅延を変更またはキャンセルできます。", 
            "ru": "Эта транзакция задержана и будет выполнена после {time_payout_after} потому что вы активировали задержку вывода токенов. Вы можете изменить или отменить задержку на странице НАСТРОЙКИ.", 
            "tr": "Bu işlem, erteleniyor ve para çekme işlemi için bir ertelemeyi etkinleştirdiğiniz için {time_payout_after} tarihinden sonra yürütülecektir. Bu ertelemeyi AYARLAR bölümünde değiştirebilir veya iptal edebilirsiniz.", 
            "uk": "Ця транзакція затримана і буде виконана після {time_payout_after} бо ви активували затримку виведення токенів. Ви можете змінити або скасувати затримку на сторінці НАЛАШТУВАННЯ.", 
            "zh": "此交易被延迟，并将在 {time_payout_after}之后执行，因为您激活了提款延迟。您可以在“设置”部分更改或取消此延迟。"
        },   
        "changeNoun": {
            "en": "Change", 
            "fr": "Modifier", 
            "it": "Modifica", 
            "ja": "変更", 
            "ru": "Изменение", 
            "tr": "Değiştir", 
            "uk": "Зміна", 
            "zh": "更改"
        }, 
        "time": {
            "en": "Time", 
            "fr": "Heure", 
            "it": "Tempo", 
            "ja": "時間", 
            "ko": "시간", 
            "ru": "Время", 
            "tr": "Zaman", 
            "uk": "Час", 
            "zh": "时间"
		},
		"amount": {
			"en": "Volume", 
			"fr": "Volume", 
			"it": "Volume", 
			"ja": "ボリューム", 
			"ru": "Объем", 
			"tr": "İşlem hacmi", 
			"uk": "Обсяг", 
			"zh": "容量"
		}, 
		"expirationTime": {
			"en": "Expiration time", 
			"fr": "Date d'expiration", 
			"it": "Scadenza", 
			"ja": "有効期限", 
			"ru": "Время отмены", 
			"tr": "Vade zamanı", 
			"uk": "Час відміни", 
			"zh": "过期时间"
		}, 
        "validUntil": {
            "en": "Valid until", 
            "fr": "Valable jusqu'à", 
            "it": "Valido fino a", 
            "ja": "有効期限：", 
            "ko": "만료시간", 
            "ru": "Действителен до", 
            "tr": "Son geçerlilik tarihi", 
            "uk": "Дійсний до", 
            "zh": "有效利用率"
        },
            "from_history": {
                "en": "Converted from History to Position", 
                "fr": "Converti de l'historique en position", 
                "it": "Convertito da Cronologia a Posizione", 
                "ja": "履歴からポジションに変換されました。", 
                "ru": "Восстановлено из Истории в Позицию", 
                "tr": "Geçmişten Konuma Dönüştürüldü", 
                "uk": "Відновлено з Історії в Позицію", 
                "zh": "从历史转换到职位"
            }, 
            "memo": {
                "en": "Note", 
                "fr": "Remarque", 
                "it": "Nota", 
                "ja": "メモ", 
                "ru": "Заметка", 
                "tr": "Not", 
                "uk": "Замітка", 
                "zh": "注意"
            }, 
            "rate": {
                "en": "Rate", 
                "fr": "Taux", 
                "it": "Tasso", 
                "ja": "レート", 
                "ru": "Цена", 
                "tr": "Oran", 
                "uk": "Ціна", 
                "zh": "比率"
            },
            "sl_r": {
                "en": "Stoploss rate", 
                "fr": "Taux Stoploss", 
                "it": "Tasso di stoploss", 
                "ja": "ストップロスレート", 
                "ru": "Цена стоплосса", 
                "tr": "Zararı durdurma satışının oranı", 
                "uk": "Ціна стоплосса", 
                "zh": "止损率"
            }, 
            "sl_trigger": {
                "en": "Stoploss trigger", 
                "fr": "Déclencheur Stoploss", 
                "it": "Trigger Stoploss", 
                "ja": "ストップロストリガー", 
                "ru": "Триггер стоплосса", 
                "tr": "Zararı durdurma satışı tetiği", 
                "uk": "Триггер стоплосса", 
                "zh": "止损触发器"
            },
        "stoploss": {
            "en": "Stoploss", 
            "fr": "Stoploss", 
            "it": "Stoploss", 
            "ja": "ストップロス", 
            "ru": "Стоплосс", 
            "tr": "Zararı durdurma satışı", 
            "uk": "Стоплосс", 
            "zh": "止损"
        }, 
        "stoplossPR": {
            "en": "Stoploss level (%)", 
            "fr": "Niveau de stoploss (%)", 
            "it": "Livello di Stoploss (%)", 
            "ja": "ストップロスレベル（％）", 
            "ko": "손실제한 수준(%)", 
            "ru": "Уровень стоп-лосса (%)", 
            "tr": "Zararı durdurma satışının seviyesi (%)", 
            "uk": "Рівень стоп-лосс (%)", 
            "zh": "止损水平(%)"
        }, 
        "stoplossRate": {
            "en": "Stoploss rate", 
            "fr": "Taux de stoploss", 
            "it": "Tasso di stoploss", 
            "ja": "ストップロスレート", 
            "ko": "손실제한 가격", 
            "ru": "Цена Стоплосса", 
            "tr": "Zararı durdurma satışının oranı", 
            "uk": "Ціна Стоплосса", 
            "zh": "止损率"
        }, 
        "stoplossRate_description": {
            "en": "<b>Stoploss Rate</b> is the limit price of your future STOPLOSS order after it has been sent to the market after Trigger Price has been reached by the trades or counter-orders on the market.", 
            "fr": "Le <b> taux Stoploss </b> est le prix limite de votre futur ordre STOPLOSS après son envoi sur le marché après que le prix de déclenchement a été atteint par les transactions ou les contre-ordres sur le marché.", 
            "it": "<b> Tasso di Stoploss </b> è il prezzo limite del tuo futuro ordine STOPLOSS dopo che è stato inviato al mercato dopo che il Prezzo Trigger è stato raggiunto dalle negoziazioni o dai contro-ordini sul mercato.", 
            "ja": "<b>ストップロスレート</b>は、市場での取引または逆注文によってトリガー価格に達し、市場に送られた後の、将来のストップロス注文のための指値です。", 
            "ru": "<b>Цена Стоплосса</b> - это лимитная цена, с которой будет выставлен СТОПЛОСС, после того как рыночные цены (сделок или контр-ордеров) достигнут значения ТРИГГЕРА СТОПЛОССА", 
            "tr": "<b>Stoploss Oranı (Zararı Durdurma Satışının Oranı)</b>, piyasadaki işlemler veya karşı komutlar tarafından Tetik Fiyatına ulaşıldıktan sonra, gelecekteki STOPLOSS (ZARARI DURDURMA SATIŞI) komutunuzun piyasaya gönderilmesinden sonraki limit fiyatıdır.", 
            "uk": "<b>Стоплосса</b> - це лімітна ціна, з якої буде виставлений СТОПЛОСС, після того як ринкові ціни (угод або контр-ордерів) досягнуть значення тригерів СТОПЛОССА", 
            "zh": "<b>止损率</b>是指在市场上的交易或反订单达到触发价格后，您的未来止损单发送到市场后的限价。"
        }, 
        "stoplossTrigger": {
            "en": "Stoploss trigger", 
            "fr": "Déclencheur de Stoploss", 
            "it": "Attivazione del Stoploss", 
            "ja": "ストップロストリガー", 
            "ru": "Триггер стоплосса", 
            "tr": "Stoploss (Zararı durdurma satışı) tetiği", 
            "uk": "Триггер стоплосса", 
            "zh": "止损触发器"
        }, 
        "stoplossTrigger_description": {
            "en": "When market price crosses, or becomes equal to, the <b>Trigger</b> value, a STOPLOSS order will be sent with the STOPLOSS PRICE as a limit price and your Takeprofit will be replaced with STOPLOSS for the unfilled volume with the same order ID.", 
            "fr": "Lorsque le prix du marché dépasse ou devient égal à la valeur <b> Déclencheur </b>, un ordre STOPLOSS sera envoyé avec le PRIX STOPLOSS comme prix limite et votre Takeprofit sera remplacé par STOPLOSS pour le volume non rempli avec le même numéro de commande.", 
            "it": "Quando il prezzo di mercato supera o diventa uguale al valore <b> Trigger </b>, un ordine STOPLOSS verrà inviato con il PREZZO STOPLOSS come prezzo limite e il Takeprofit verrà sostituito con STOPLOSS per il volume non riempito con lo stesso identificante per l'ordine.", 
            "ja": "市場価格が<b>トリガー</b>の値を超えるか、これに等しくなると、ストップロス価格が指値としてストップロス注文が送信され、テイクプロフィットは、同じ注文IDにて、未決済のボリュームに対して、ストップロスに置き換えられます。", 
            "ru": "Когда рыночная цена будет равной или пересечет значение <b>Триггера Стоплосса</b>, будет выставлен СТОПЛОСС с лимитной ценой ЦЕНА СТОПЛОССА, заменив собой ТЕЙКПРОФИТ с объемом равным неисполненной части Тейкпрофита", 
            "tr": "Piyasa fiyatı <b>Tetik</b> değerini geçtiğinde veya ona eşit olduğunda, bir STOPLOSS (ZARARI DURDURMA SATIŞI) komutu STOPLOSS (ZARARI DURDURMA SATIŞI) FİYATI ile sınır fiyat olarak gönderilecek ve Takeprofit'iniz (kazanç sağlama), aynı komut kimliğine sahip gerçekleştirilmemiş işlem hacmi için STOPLOSS (ZARARI DURDURMA SATIŞI) ile değiştirilecektir.", 
            "uk": "Коли ринкова ціна буде рівною або перетне значення <b>Трігера Стоплосса</b>, буде виставлений СТОПЛОСС з лімітної ціною ЦІНА СТОПЛОССА, замінивши собою ТЕЙКПРОФІТ з об'ємом рівним не виконаній частині Тейкпрофіта", 
            "zh": "当市场价格超过或等于触发器值时，将发送一个以止损价格为限制价的止损单，对于具有相同订单ID的未填充量，您的利润将替换为止损单。"
        },
        "signin": {
            "en": "Sign in",
            "fr": "Connectez-vous",
            "it": "Log in",
            "ja": "サインイン",
            "ko": "로그인",
            "ru": "Войти",
            "tr": "Oturum aç",
            "uk": "Увійти",
            "zh": "登录"
        },
        "signup": {
            "en": "Sign up",
            "fr": "Inscrivez-vous",
            "it": "Iscriviti",
            "ja": "サインアップ",
            "ko": "등록",
            "ru": "Регистрация",
            "tr": "Kaydol",
            "uk": "Реєстрація",
            "zh": "注册"
        },
        "slippage": {
            "en": "Slipage",
            "fr": "Glissement",
            "it": "Slittamento",
            "ja": "スリッページ",
            "ko": "슬리피지",
            "ru": "Проскальзывание",
            "tr": "Kayma",
            "uk": "Прослизання",
            "zh": "滑页"
        },
        "slippagePR": {
            "en": "Slipage percent",
            "fr": "Pourcentage de glissement",
            "it": "Percentuale di slippage",
            "ja": "スリッページの割合",
            "ru": "Проскальзывание в %",
            "tr": "Kayma yüzdesi",
            "uk": "Прослизання в %",
            "zh": "Slipage百分比"
        },
        "slippage_description": {
            "en": "When your TRAILING STOP is activated by the market price movement, the actual order price will be set with the given offset from the last value of the TRIGGER PRICE. To increase chances of immediate fulfillment of your TRAILING STOP, put a positive value. The exact value must be adjusted according to the volume of your order and an expected liquidity on the market at the moment of Trigger activation.",
            "fr": "Lorsque votre TRAILING STOP est activé par le mouvement du prix du marché, le prix réel de l'ordre sera fixé avec le décalage donné par rapport à la dernière valeur du TRIGGER PRICE. Pour augmenter les chances de réalisation immédiate de votre TRAILING STOP, mettez une valeur positive. La valeur exacte doit être ajustée en fonction du volume de votre commande et d'une liquidité attendue sur le marché au moment de l'activation du Trigger.",
            "it": "Quando il tuo TRAILING STOP viene attivato dal movimento del prezzo di mercato, il prezzo effettivo dell'ordine verrà impostato con l'offset dato dall'ultimo valore del PREZZO TRIGGER. Per aumentare le possibilità di realizzazione immediata del tuo TRAILING STOP, inserisci un valore positivo. Il valore esatto deve essere regolato in base al volume dell'ordine e alla liquidità prevista sul mercato al momento dell'attivazione del Trigger.",
            "ja": "トレーリングストップが市場価格の動きによって有効になると、実際の注文価格は、トリガープライスの最後の値に特定のオフセットを施した価格になります。トレーリングストップがすぐに実行される可能性を高めるには、正の値を設定してください。正確な値は、注文の量とトリガーが有効化されたタイミングでの市場で予想される流動性に応じて調整されます。",
            "ru": "Когда ваш трейлинг-стоп активируется из-за изменения рыночных цен на величину большую, чем значение ОТСТУПА ТРЕЙЛИНГА, ваш Тейкпрофит будет замещен на ТРЕЙЛИНГ СТОП с объемом равным неисполненному объему ТЕЙКПРОФИТА и ценой хуже цены ОТСТУПА ТРЕЙЛИНГА на величину ПРОСКАЛЬЗЫВАНИЯ в процентах. Чтобы увеличить шансы на немедленное исполнение, вводите положительные значения, которые должны зависеть от размера вашего ордера (чем больше ордер, тем больше отступ) и от ожидаемой ликвидности на рынке в момент предполагаемого срабатывания (чем меньшую ликвидность вы ожидаете увидеть, там больше должно быть значение ПРОСКАЛЬЗЫВАНИЯ).",
            "tr": "TRAILING STOP'unuz (TAKİP EDEN ZARAR DURDUR EMRİ) piyasa fiyatı hareketi ile etkinleştirildiğinde; gerçek komut fiyatı, TETİK FİYATI'nın son değerinden verilen mahsup ile ayarlanacaktır. TRAILING STOP'unuzun (TAKİP EDEN ZARAR DURDUR EMRİ) anında yerine getirilmesi üzerine şansınızı artırmak için pozitif bir değer verin. Kesin değer, komutunuzun işlem hacmine ve Tetik aktivasyonu sırasında piyasada beklenen likiditeye göre ayarlanmalıdır.",
            "uk": "Коли ваш трейлинг-стоп активується через зміну ринкових цін на величину більшу, ніж значення ВІДСТУПУ ТРЕЙЛИНГА, ваш Тейкпрофіт буде заміщений на ТРЕЙЛИНГ СТОП з об'ємом рівним невиконанному обсягу ТЕЙКПРОФІТА і ціною гірше ціни ВІДСТУПУ ТРЕЙЛИНГА на величину Прослизання в процентах. Щоб збільшити шанси на негайне виконання, вводьте позитивні значення, які повинні залежати від розміру вашого ордера (чим більше ордер, тим більше відступ) і від очікуваної ліквідності на ринку в момент передбачуваного спрацьовування (чим меншу ліквідність ви очікуєте побачити, там більше має бути значення прослизання).",
            "zh": "当您的尾随止损被市场价格变动激活时，实际订单价格将设置为触发价格的最后一个值的给定偏移量。若要增加立即完成尾随停止的机会，请输入正值。确切的价值必须根据您的订单量和触发激活时市场上的预期流动性进行调整。"
        },
		"tp_r": {
			"en": "Takeprofit rate", 
			"fr": "Taux de profit", 
			"it": "Tasso di profitto", 
			"ja": "テイクプロフィットレート", 
			"ru": "Цена тейкпрофита", 
			"tr": "Kazanç sağlama oranı", 
			"uk": "Ціна тейкпрофіта", 
			"zh": "净利润率"
		}, 
        "trailing": {
            "en": "Trailing offset", 
            "fr": "Décalage de la fuite",
            "ja": "トレーリングオフセット",
            "ru": "Отступ трейлинга",
            "tr": "Takip eden mahsup",
            "uk": "Відступ трейлинга",
            "zh": "尾随偏移量"
        }, 
        "trailingPR": {
            "en": "Trailing offset (%)", 
            "fr": "Décalage de la fuite (%)", 
            "it": "Trailing offset (%)", 
            "ja": "トレーリングオフセット（%）", 
            "ru": "Отступ трейлинга (%)", 
            "tr": "Takip eden mahsup (%)", 
            "uk": "Відступ трейлинга (%)", 
            "zh": "尾随偏移量 (%)"
        }, 
        "trailing_description": {
            "en": "The TRIGGER PRICE of Your TRAILING STOP order will be automatically updated to stay no more than a given percent from the maximum (for buy orders) or minimum (for sell orders) market price since the parent orders' fulfillment.", 
            "fr": "Le PRIX DE DÉCLENCHEMENT de votre ordre TRAILING STOP sera automatiquement mis à jour pour ne pas dépasser un pourcentage donné du prix du marché maximum (pour les ordres d'achat) ou minimum (pour les ordres de vente) depuis l'exécution des ordres parents.", 
            "it": "Il PREZZO DI ATTIVAZIONE (TRIGGER PRICE) del tuo ordine di TRAILING STOP verrà automaticamente aggiornato per rimanere non più di una determinata percentuale dal prezzo di mercato massimo (per ordini di acquisto) o minimo (per ordini di vendita) dall'esecuzione degli ordini principali.", 
            "ja": "トレーリングストップ注文のトリガープライスは、ペアレントオーダーの確定以降の最高（買い注文の場合）または最低（売り注文の場合）の市場価格から一定の割合を超えないように自動的に更新されます。", 
            "ru": "ТРИГГЕР СТОПЛОССА будет изменяться автоматически, чтобы оставаться не далее введенного значения в процентах от максимальных (для ордеров покупки) или минимальных (для ордеров продажи) рыночных цен с момента полного исполнения родительского ордера.", 
            "tr": "TRAILING STOP (TAKİP EDEN ZARAR DURDUR EMRİ) komutunuzun TRIGGER (TETİK) FİYATI, ana komutların yerine getirilmesinden bu yana maksimum (satın alma komutları için) veya minimum (satış komutları için) piyasa fiyatı üzerinden, verilen belirli bir yüzdeden fazla olmayacak şekilde otomatik olarak güncellenecektir.", 
            "uk": "Тригер СТОПЛОССА буде змінюватися автоматично, щоб залишатися не далі введеного значення в процентах від максимальних (для ордерів покупки) або мінімальних (для ордерів продажу) ринкових цін з моменту повного виконання батьківського ордера.", 
            "zh": "您的尾停订单的触发价格将自动更新，以保持不超过给定百分比从最大（购买订单）或最低（销售订单）的市场价格，因为家长订单的履行。"
        }, 
        "trailingStop": {
            "en": "Trailing Stop", 
            "fr": "Trailing Stop", 
            "it": "Trailing Stop", 
            "ja": "トレーリングストップ", 
            "ru": "Скользящий Стоп", 
            "tr": "Takip eden zarar durdur emri", 
            "uk": "Ковзаючий Стоп", 
            "zh": "尾随止动块"
        }, 
        "tag": {
            "en": "Tag(memo)", 
            "ja": "タグ", 
            "ru": "Tag(memo)", 
            "tr": "Etiket", 
            "uk": "Тег", 
            "zh": "标签"
        }, 
        "takeprofitPR": {
            "en": "Takeprofit (%)", 
            "fr": "Takeprofit (%)", 
            "it": "Takeprofit (%)", 
            "ja": "テイクプロフィット（%）", 
            "ko": "이익실현 수준(%)", 
            "ru": "Тейкпрофит (%)", 
            "tr": "Kazanç sağlama (%)", 
            "uk": "Тейкпрофіт (%)", 
            "zh": "净利润 (%)"
        },  
        "takeprofit": {
            "en": "Takeprofit", 
            "fr": "Takeprofit", 
            "it": "Takeprofit", 
            "ja": "テイクプロフィット", 
            "ko": "이익실현 수준", 
            "ru": "Тейкпрофит", 
            "tr": "Kazanç sağlama", 
            "uk": "Тейкпрофіт", 
            "zh": "净利润"
        }, 
        "takeprofitRate": {
            "en": "Takeprofit Rate", 
            "fr": "Taux de Takeprofit", 
            "it": "Tasso di takeprofit", 
            "ja": "テイクプロフィットレート", 
            "ko": "이익실현 가격", 
            "ru": "Тейкпрофит Цена", 
            "tr": "Kazanç sağlama oranı", 
            "uk": "Тейкпрофіт Ціна", 
            "zh": "净利润率"
        }, 
        "takeprofitRate_description": {
            "en": "<b>Takeprofit Rate</b> is the limit price of the TAKEPROFIT order to be set after your parent order has been fully filled.", 
            "fr": "<b>Takeprofit Rate</b> est le prix limite de la commande TAKEPROFIT à définir une fois que votre commande parent a été entièrement exécutée.", 
            "it": "<b> Tasso di takeprofit </b> è il prezzo limite dell'ordine TAKEPROFIT da impostare dopo che l'ordine parente è stato completamente eseguito.", 
            "ja": "<b>テイクプロフィットレート</b>とは、ペアレントオーダーが完全に約定された後に設定されるテイクプロフィット注文の指値です。", 
            "ru": "<b>Цена Тейкпрофита</b> - это лимитная цена ТЕЙКПРОФИТА, по которой он будет выставлен после полного исполнения родительского ордера", 
            "tr": "<b>Takeprofit (Kazanç sağlama) Oranı</b> üst komutunuz tamamen gerçekleştirildikten sonra ayarlanacak TAKEPROFIT (KAZANÇ SAĞLAMA) komutunun limit fiyatıdır.", 
            "uk": "<b>Ціна Тейкпрофіта</b> - це лімітна ціна ТЕЙКПРОФІТА, по якій він буде виставлений після повного виконання батьківського ордера", 
            "zh": "<b>净利润率</b>是在您的父订单完全填写后要设置的净利润订单的限制价格。"
        },  
            "vol": {
                "en": "Volume", 
                "fr": "Volume", 
                "it": "Volume", 
                "ja": "ボリューム", 
                "ru": "Объем", 
                "tr": "İşlem Hacmi", 
                "uk": "Обсяг", 
                "zh": "容量"
            },
        "volume": {
            "en": "Volume", 
            "fr": "Volume", 
            "it": "Volume", 
            "ja": "ボリューム", 
            "ko": "수량", 
            "ru": "Количество", 
            "tr": "İşlem hacmi", 
            "uk": "Кількість", 
            "zh": "音量"
        },
        "price": {
            "en": "Price", 
            "fr": "Prix", 
            "it": "Prezzo", 
            "ja": "価格", 
            "ko": "가격", 
            "ru": "Цена", 
            "tr": "Fiyat", 
            "uk": "Ціна", 
            "zh": "价格"
        }, 
        "new_price": {
            "en": "New price", 
            "ru": "Новая цена"
        }, 
        "priceFor1": {
            "en": "Price for 1 {sym1}", 
            "fr": "Prix pour un 1 {sym1}", 
            "it": "Prezzo per 1 {sym1}", 
            "ja": "1 {sym1}の価格", 
            "ru": "Цена за 1 {sym1}", 
            "tr": "1 {sym1} için fiyat", 
            "uk": "Ціна за 1 {sym1}", 
            "zh": "1{sym1}的价格"
        }, 
        "profit": {
            "en": "Profit", 
            "fr": "Revenu", 
            "it": "Guadagni", 
            "ja": "利益", 
            "ru": "Прибыль", 
            "tr": "Kâr", 
            "uk": "Прибуток", 
            "zh": "利润"
        },
		"asset": {
			"en": "Asset", 
            "de": "Anlagegut", 
            "fr": "Actif", 
            "it": "Risorsa", 
            "ja": "資産", 
            "ko": "유산", 
            "ru": "Актив", 
            "tr": "Varlık", 
            "uk": "Актив", 
            "zh": "资产"
		},
        "coin": {
            "en": "Coin", 
            "fr": "Monnaie", 
            "it": "Moneta", 
            "ja": "コイン", 
            "ko": "코인", 
            "ru": "Монета", 
            "tr": "Coin", 
            "uk": "Монета", 
            "zh": "硬币"
        },
		"сurrency": {
            "en": "Currency", 
            "de": "Währung", 
            "fr": "Devise", 
            "it": "Valuta", 
            "ja": "通貨", 
            "ko": "통화", 
            "ru": "Валюта", 
            "tr": "Para birimi", 
            "uk": "Валюта", 
            "zh": "货币"
		},
		"cryptoсurrency": {
            "en": "Cryptocurrency", 
            "de": "Kryptowährung", 
            "fr": "Crypto-monnaie", 
            "it": "Criptovaluta", 
            "ja": "暗号通貨", 
            "ko": "암호 화폐", 
            "ru": "Криптовалюта", 
            "tr": "Kripto para", 
            "uk": "Криптовалюта", 
            "zh": "加密货币"
		},
		"token": {
			"en": "Token",
            "de": "Zeichen", 
            "fr": "Jeton", 
            "it": "Gettone", 
            "ja": "トークン", 
			"ko": "암호 화폐",
            "ru": "Токен", 
			"tr": "Jeton", 
			"uk": "Токен", 
			"zh": "代币" 
		}, 
		"txh": {
			"en": "Transaction Hash/ID", 
			"de": "Transaktions-Hash / ID", 
			"fr": "Hash / ID de transaction", 
			"it": "Hash / ID transazione", 
			"ja": "ID (ハッシュ)", 
			"ko": "트랜잭션 해시 / ID", 
			"ru": "ID/Хэш транзакции", 
			"tr": "İşlem Karması/Kimliği", 
			"uk": "Хеш/ID транзакції", 
			"zh": "ID（哈希"
		},
        "timePayout": {
            "en": "Payout time", 
            "fr": "Temps de paiement", 
            "it": "Tempo di pagamento", 
            "ja": "払い出し時間", 
            "ko": "지불 시간", 
            "ru": "Время выплаты", 
            "tr": "Ödeme zamanı", 
            "uk": "Час виплати", 
            "zh": "付款时间"
        },
        "button_createNew": {
            "en": "Create new", 
            "fr": "Créer un nouveau", 
            "it": "Creare nuovo", 
            "ja": "新規作成", 
            "ko": "새로 만들기", 
            "ru": "Создать новый", 
            "tr": "Yeni oluştur", 
            "uk": "Створити новий", 
            "zh": "新建"
        },
        "landingPage": {
            "en": "Main landing page",
            "ru": "Главная страница (лендинг)"
        },
        "50x50": {
            "ar": "", 
            "de": "50x50 Empfehlungsprogramm", 
            "en": "50x50 Referral Program", 
            "fr": "Programme de référence 50x50", 
            "he": "", 
            "it": "Programma di riferimento 50x50", 
            "ja": "50x50紹介プログラム", 
            "ko": "50x50 추천 프로그램", 
            "ru": "Партнерская программа 50x50", 
            "sp": "Programa de Referencia 50x50", 
            "test": "", 
            "tr": "50x50 Referans Programı", 
            "uk": "Партнерська програма 50х50", 
            "zh": "50x50推荐计划"
        }, 
        "address": {
            "en": "Address", 
            "fr": "Adresse", 
            "it": "Indirizzo", 
            "ja": "アドレス", 
            "ko": "주소", 
            "ru": "Адрес", 
            "tr": "Adres", 
            "uk": "Адреса", 
            "zh": "地址"
        }, 
        "answerShort": {
            "en": "A:", 
            "fr": "A:", 
            "it": "A:", 
            "ja": "A:", 
            "ko": "", 
            "ru": "О:", 
            "tr": "A:", 
            "uk": "В:", 
            "zh": "答："
        }, 
        "api": {
            "en": "API", 
            "fr": "API", 
            "it": "API", 
            "ja": "API", 
            "tr": "API", 
            "uk": "API", 
            "zh": "API"
        }, 
        "apiManual": {
            "en": "API Manual", 
            "fr": "Manuel de l'API", 
            "it": "Manuale API", 
            "ja": "APIマニュアル", 
            "ko": "API 메뉴얼", 
            "tr": "API Kılavuzu", 
            "uk": "АРІ Інструкція", 
            "zh": "API手册"
        }, 
        "attention": {
            "en": "Attention!", 
            "fr": "Attention!", 
            "it": "Attenzione!", 
            "ja": "注意！", 
            "ko": "주의하세요!", 
            "ru": "Внимание!", 
            "tr": "Dikkat!", 
            "uk": "Увага!", 
            "zh": "注意！"
        }, 
        "available": {
            "en": "Available", 
            "fr": "Disponible", 
            "it": "Disponible", 
            "ja": "利用可能", 
            "ko": "주문 가능 금액", 
            "ru": "Доступно", 
            "tr": "Mevcut", 
            "uk": "Доступно", 
            "zh": "可用"
        }, 
        "betaTerminal": {
            "en": "Beta terminal", 
            "fr": "Terminal bêta", 
            "it": "Beta terminal", 
            "ja": "ベータターミナル", 
            "ru": "Бета версия", 
            "tr": "Beta terminali", 
            "uk": "Бета версія", 
            "zh": "Beta 终点站"
        }, 
        "blockExplorer": {
            "en": "Block explorer", 
            "fr": "Explorateur de blocs", 
            "it": "Block explorer", 
            "ja": "ブロックエクスプローラ", 
            "ru": "Блок эксплорер", 
            "tr": "Blok gezgini", 
            "uk": "Блок експлорер", 
            "zh": "块资源管理器"
        }, 
        "blockchain": {
            "en": "Blockchain", 
            "fr": "Blockchain", 
            "it": "Blockchain", 
            "ja": "ブロックチェーン", 
            "ru": "Блокчейн", 
            "tr": "Blok zinciri", 
            "uk": "Блокчейн", 
            "zh": "块链"
        }, 
        "botsAreWelcome": {
            "de": "Bots sind willkommen", 
            "en": "Bots Are Welcome", 
            "fr": "Les Bots sont les bienvenus", 
            "it": "I Robot Sono i Benvenuti", 
            "ja": "ボット大歓迎", 
            "ko": "트레이딩 봇을 환영합니다", 
            "ru": "Боты приветствуются", 
            "sp": "Los Bots Son Bienvenidos", 
            "tr": "Botlar Kabul Edilir", 
            "uk": "Ботам завжди раді", 
            "zh": "欢迎使用机器人"
        }, 
        "button_back": {
            "en": "Back", 
            "fr": "Retourner", 
            "it": "Indietra", 
            "ja": "戻る", 
            "ko": "뒤로", 
            "ru": "Назад", 
            "tr": "Geri", 
            "uk": "Назад", 
            "zh": "后面"
        }, 
        "button_cancel": {
            "en": "Cancel", 
            "fr": "Annuler", 
            "it": "Annulla", 
            "ja": "キャンセル", 
            "ru": "Отмена", 
            "tr": "İptal", 
            "uk": "Відміна", 
            "zh": "取消"
        }, 
        "button_change": {
            "en": "Change", 
            "fr": "Modifier", 
            "it": "Modificare", 
            "ja": "変更", 
            "ko": "변경", 
            "ru": "Изменить", 
            "tr": "Değişiklik", 
            "uk": "Змінити", 
            "zh": "改变"
        },
        "button_convertDust": {
            "en": "Convert all {sym} to A2A",
            "ru": "Конвертировать остаток {sym} в A2A"
        },
        "button_close": {
            "en": "Close", 
            "fr": "Fermer", 
            "it": "Chiudere", 
            "ja": "閉じる", 
            "ru": "Закрыть", 
            "tr": "Kapat", 
            "uk": "Закрити", 
            "zh": "关闭"
        },
        "button_confirm": {
            "en": "Confirm", 
            "fr": "Valider", 
            "it": "Confermare", 
            "ja": "確定", 
            "ko": "확인", 
            "ru": "Подтвердить", 
            "tr": "Onay", 
            "uk": "Підтвердити", 
            "zh": "确认"
        }, 
        "button_create": {
            "en": "Create", 
            "fr": "Créer", 
            "it": "Creare", 
            "ja": "新規作成", 
            "ko": "생성", 
            "ru": "Создать", 
            "tr": "Oluştur", 
            "uk": "Створити", 
            "zh": "创建"
        }, 
        "button_decline": {
            "en": "Decline", 
            "fr": "Refuse", 
            "it": "Rifiutare", 
            "ja": "拒否する", 
            "ru": "Отклонить", 
            "tr": "Fiyatın düşme eğilimi", 
            "uk": "Відхилити", 
            "zh": "拒绝"
        }, 
        "button_default": {
            "en": "Default", 
            "fr": "Par défaut", 
            "it": "Predefinito", 
            "ja": "デフォルト", 
            "ru": "По умолчанию", 
            "tr": "Gecikme", 
            "uk": "За замовчуванням", 
            "zh": "违约"
        }, 
        "button_delete": {
            "en": "Remove", 
            "fr": "Supprimer", 
            "it": "Rimuovere", 
            "ja": "削除", 
            "ko": "삭제", 
            "ru": "Удалить", 
            "tr": "Giderme", 
            "uk": "Видалити", 
            "zh": "删除"
        },
        "button_deny": {
            "en": "Deny", 
            "fr": "Refuser", 
            "it": "Negare", 
            "ja": "拒否", 
            "ru": "Отклонить", 
            "tr": "Reddet", 
            "uk": "Відхилити", 
            "zh": "否认"
        }, 
        "button_continue": {
            "en": "Continue", 
            "fr": "Continuer", 
            "it": "Continua", 
            "ja": "続行", 
            "ru": "Продолжить", 
            "tr": "Devam et", 
            "uk": "Продовжити", 
            "zh": "继续"
        }, 
        "button_copy": {
            "en": "Copy", 
            "fr": "Copier", 
            "it": "Copiare", 
            "ja": "コピー", 
            "ko": "복사", 
            "ru": "Копировать", 
            "tr": "Kopya", 
            "uk": "Копіювати", 
            "zh": "复制"
        }, 
        "button_getPaymentAddress": {
            "en": "Get payment address", 
            "fr": "Obtenir l'adresse de paiement", 
            "it": "Ottieni l'indirizzo di pagamento", 
            "ja": "支払いアドアレスを取得", 
            "ko": "결제주소 가져오기", 
            "ru": "Получить адрес оплаты", 
            "tr": "Ödeme adresi al", 
            "uk": "Отримати адресу оплати", 
            "zh": "获取付款地址"
        }, 
        "button_join": {
            "en": "Join", 
            "fr": "Joindre", 
            "it": "Aderire", 
            "ja": "参加", 
            "ko": "참여하기", 
            "ru": "Присоединиться", 
            "tr": "Katıl", 
            "uk": "Приєднатися", 
            "zh": "加入"
        }, 
        "button_learnMore": {
            "ar": "", 
            "de": "WEITERLESEN", 
            "en": "LEARN MORE", 
            "fr": "EN SAVOIR PLUS", 
            "he": "", 
            "it": "PER SAPERNE DI PIÙ", 
            "ja": "もっと知る", 
            "ko": "더 알아보기", 
            "no": "LÆR MER", 
            "ru": "Подробнее", 
            "sp": "CONOCE MÁS", 
            "test": "学到更多", 
            "tr": "DAHA FAZLA BİLGİ EDİN", 
            "uk": "Детальніше", 
            "zh": "了解更多"
        }, 
        "button_menu": {
            "en": "Menu", 
            "fr": "Menu", 
            "it": "Menu", 
            "ja": "メニュー", 
            "ko": "메뉴", 
            "ru": "Меню", 
            "tr": "Menü", 
            "uk": "Меню", 
            "zh": "菜单"
        }, 
        "button_reset": {
            "en": "Reset", 
            "ru": "Сброс"
        }, 
        "button_save": {
            "en": "Save", 
            "fr": "Sauvegarder", 
            "it": "Salva", 
            "ja": "保存", 
            "ko": "저장", 
            "ru": "Сохранить", 
            "tr": "Kaydet", 
            "uk": "Зберегти", 
            "zh": "保存"
        },  
        "button_load": {
            "en": "Load", 
            "ru": "Загрузить"
        },
        "button_send": {
            "en": "Send", 
            "fr": "Envoyer", 
            "it": "Invia", 
            "ja": "送信", 
            "ko": "보내기", 
            "ru": "Отправить", 
            "tr": "Gönder", 
            "uk": "Відправити", 
            "zh": "发送"
        }, 
        "button_sendRequest": {
            "ar": "", 
            "de": "", 
            "en": "SEND REQUEST", 
            "fr": "ENVOYER UNE DEMANDE", 
            "he": "", 
            "it": "INVIA RICHIESTA", 
            "ja": "リクエストを送信", 
            "ko": "신청서 보내기", 
            "ru": "ОТПРАВИТЬ ЗАПРОС", 
            "sp": "", 
            "test": "", 
            "tr": "İSTEK GÖNDER", 
            "uk": "ВІДПРАВИТИ ЗАПИТ", 
            "zh": "发送请求"
        }, 
        "button_show": {
            "en": "Show", 
            "fr": "Afficher", 
            "it": "Mostra", 
            "ja": "表示", 
            "ru": "Показать", 
            "tr": "Göster", 
            "uk": "Показати", 
            "zh": "显示"
        }, 
        "button_showBalance": {
            "en": "Show the balance", 
            "fr": "Montrez le solde", 
            "it": "Mostra il saldo", 
            "ja": "残高を表示", 
            "ko": "보상금 잔액 확인하기", 
            "ru": "Показать баланс", 
            "tr": "Bakiyeyi göster", 
            "uk": "Показати баланс", 
            "zh": "起价<strong>4 ETH/1000 50X100</strong>最后一个代币可能以100 ETH/1000 50X100出售"
        }, 
        "button_signin": {
            "ar": "", 
            "de": "ANMELDEN", 
            "en": "SIGN IN", 
            "fr": "SE CONNECTER", 
            "he": "", 
            "it": "REGISTRATI", 
            "ja": "サインイン", 
            "ko": "로그인", 
            "no": "LOGG INN", 
            "ru": "Войти", 
            "sp": "REGISTRARSE", 
            "test": "登入", 
            "tr": "OTURUM AÇ", 
            "uk": "УВІЙТИ", 
            "zh": "登录"
        }, 
        "button_signup": {
            "en": "SIGN UP", 
            "fr": "S'INSCRIRE", 
            "it": "Iscriviti", 
            "ja": "サインアップ", 
            "ko": "등록", 
            "ru": "Создать аккаунт", 
            "tr": "KAYDOL", 
            "uk": "Створіть акаунт", 
            "zh": "注册"
        }, 
        "button_signupNow": {
            "ar": "", 
            "de": "JETZT ANMELDEN!", 
            "en": "SIGN UP NOW !", 
            "fr": "INSCRIVEZ-VOUS MAINTENANT !", 
            "he": "", 
            "it": "ISCRIVITI ORA!", 
            "ja": "今すぐ登録！", 
            "ko": "지금 가입하세요 !", 
            "no": "BLI MED NÅ !", 
            "ru": "Создайте аккаунт", 
            "sp": "¡INSCRÍBETE AHORA!", 
            "test": "立即注册 ！", 
            "tr": "ŞİMDİ KAYDOL !", 
            "uk": "Створіть акаунт", 
            "zh": "马上注册！"
        }, 
        "button_withdraw": {
            "en": "Withdraw balance", 
            "fr": "Retirer le solde", 
            "it": "Prelevare il saldo", 
            "ja": "出金残高", 
            "ko": "출금 잔액", 
            "ru": "Вывести средства", 
            "tr": "Para çekme bakiyesi", 
            "uk": "Вивести кошти", 
            "zh": "提取余额"
        }, 
        "confirmationRequired": {
            "en": "Please confirm", 
            "fr": "Veuillez confirmer", 
            "it": "Si prega di confermare", 
            "ja": "確認を行ってください", 
            "ru": "Подтвердите", 
            "tr": "Lütfen onaylayın", 
            "uk": "Підтвердіть", 
            "zh": "请确认"
        },
        "clicks": {
            "en": "Clicks", 
            "fr": "Clics", 
            "it": "Clic", 
            "ja": "クリック数", 
            "ko": "", 
            "ru": "Клики", 
            "tr": "Tıklanma", 
            "uk": "Кліки", 
            "zh": "点击"
        }, 
        "unique": {
            "en": "Unique",
            "ru": "Уникальные"
        }, 
		"uniqueClicks": {
			"en": "Unique Clicks", 
			"fr": "Clics uniques", 
			"it": "Clic unici", 
			"ja": "ユニーククリック数", 
			"ko": "유효 클릭", 
			"ru": "Уникальных переходов", 
			"tr": "Benzersiz Tıklamalar", 
			"uk": "Унікальних відвідувачів", 
			"zh": "独特的点击"
		},
        "cloud": {
            "ar": "", 
            "de": "CLOUD", 
            "en": "CLOUD", 
            "fr": "CLOUD", 
            "he": "", 
            "it": "CLOUD", 
            "ja": "クラウド", 
            "ko": "클라우드", 
            "no": "CLOUD", 
            "ru": "Облако", 
            "sp": "Nube", 
            "test": "云端", 
            "tr": "CLOUD (BULUT)", 
            "uk": "Хмара", 
            "zh": "云"
        }, 
        "contacts": {
            "ar": "", 
            "de": "Kontakte", 
            "en": "Contacts", 
            "fr": "Contacts", 
            "he": "", 
            "it": "Contatti", 
            "ja": "コンタクト", 
            "ko": "연락하기", 
            "no": "Kontakter", 
            "ru": "Контакты", 
            "sp": "Contacto", 
            "test": "联络人", 
            "tr": "Kişiler", 
            "uk": "Контакти", 
            "zh": "联系人"
        }, 
        "country": {
            "ar": "", 
            "de": "", 
            "en": "Country", 
            "fr": "Pays", 
            "he": "", 
            "it": "Paese", 
            "ja": "国", 
            "ko": "", 
            "ru": "Страна", 
            "sp": "", 
            "test": "", 
            "tr": "Ülke", 
            "uk": "Країна", 
            "zh": "国家"
        }, 
        "currentBalance": {
            "en": "Current balance", 
            "fr": "Solde actuel", 
            "it": "Bilancio corrente", 
            "ja": "現在の残高", 
            "ru": "Текущий баланс", 
            "tr": "Mevcut bakiye", 
            "uk": "Поточний баланс", 
            "zh": "当前余额"
        }, 
        "currentSupply": {
            "en": "Current supply", 
            "fr": "Offre actuelle", 
            "it": "Fornitura attuale", 
            "ja": "現在の流通量", 
            "ru": "Сейчас в обращении", 
            "tr": "Cari arz", 
            "uk": "Зараз в обігу", 
            "zh": "近期供应"
        },
        "decimals": {
            "en": "Decimals", 
            "fr": "Décimales", 
            "it": "Decimali", 
            "ja": "小数点", 
            "ru": "Десятичных знаков", 
            "tr": "Ondalık sayılar", 
            "uk": "Десяткових знаків", 
            "zh": "小数"
        }, 
        "distributionShare": {
            "en": "Distribution share", 
            "fr": "Part de distribution", 
            "it": "Quota di distribuzione", 
            "ja": "分配シェア", 
            "ru": "Доля распределения", 
            "tr": "Dağıtım payı", 
            "uk": "Частка розподілу", 
            "zh": "分配份额"
        }, 
        "earning": {
            "en": "Earning", 
            "fr": "Revenus", 
            "it": "Guadagno", 
            "ja": "収益", 
            "ko": "수입", 
            "ru": "Начислено", 
            "tr": "Kazanç", 
            "uk": "Нараховано", 
            "zh": "收入"
        }, 
        "efficiency": {
            "en": "Efficiency", 
            "fr": "Efficacité", 
            "it": "Efficienza", 
            "ja": "効率性", 
            "ko": "", 
            "ru": "Эффективность", 
            "tr": "Etkinlik", 
            "uk": "Ефективність", 
            "zh": "效率"
        }, 
        "email": {
            "en": "E-Mail:", 
            "fr": "Courriel:", 
            "it": "E-Mail:", 
            "ja": "メールアドレス：", 
            "ko": "이메일 ", 
            "ru": "Электронная почта:", 
            "tr": "E-Posta", 
            "uk": "Електронна пошта:", 
            "zh": "电子邮件："
        }, 
        "email_support_value": {
            "en": "support@50x.com", 
            "fr": "support@50x.com", 
            "it": "support@50x.com", 
            "ja": "support@50x.com", 
            "tr": "support@50x.com", 
            "uk": "support@50x.com", 
            "zh": "邮箱：support@50x.com"
        }, 
        "enterYourEthAddress": {
            "en": "Enter your Ethereum address", 
            "fr": "Entrez votre adresse Ethereum", 
            "it": "Inserisci il tuo indirizzo Ethereum", 
            "ja": "イーサリアムのアドレスを入力", 
            "ko": "당신의 이더리움(ETH) 지갑 주소를 입력해주세요", 
            "ru": "Введите ваш адрес Ethereum", 
            "tr": "Ethereum adresinizi girin", 
            "uk": "Введіть вашу адресу Ethereum", 
            "zh": "输入以太坊地址"
        }, 
        "error": {
            "ar": "", 
            "de": "", 
            "en": "Error", 
            "fr": "Erreur", 
            "he": "", 
            "it": "Errore", 
            "ja": "エラー", 
            "ko": "오류", 
            "ru": "Ошибка", 
            "sp": "", 
            "test": "", 
            "tr": "Hata", 
            "uk": "Помилка", 
            "zh": "错误"
        }, 
        "error_invalid_address": {
            "en": "Invalid address", 
            "fr": "Adresse invalide", 
            "it": "Indirizzo non valido", 
            "ja": "アドレスが有効ではありません", 
            "ru": "Неверный формат адреса", 
            "tr": "Geçersiz adres", 
            "uk": "Невірний формат адреси", 
            "zh": "无效地址"
        }, 
        "ethAddres_placeholder": {
            "en": "Enter your Ethereum address", 
            "fr": "Entrez votre adresse Ethereum", 
            "it": "Inserisci il tuo indirizzo Ethereum", 
            "ja": "イーサリアムのアドレスを入力してください", 
            "ko": "당신의 이더리움(ETH) 지갑 주소를 입력해주세요", 
            "ru": "Введите ваш адрес Ethereum", 
            "tr": "Ethereum adresinizi girin", 
            "uk": "Введіть вашу адресу Ethereum", 
            "zh": "输入以太坊地址"
        }, 
        "failed": {
            "ar": "", 
            "de": "", 
            "en": "Failed! ", 
            "fr": "Échoué!", 
            "he": "", 
            "it": "Fallito!", 
            "ja": "失敗！", 
            "ko": "실패했습니다! ", 
            "ru": "Сбой! ", 
            "sp": "", 
            "test": "", 
            "tr": "Başarısız oldu!", 
            "uk": "Збій!", 
            "zh": "失败！"
        }, 
        "fees": {
            "ar": "", 
            "de": "Gebühren", 
            "en": "Fees", 
            "fr": "Frais", 
            "he": "", 
            "it": "Commissioni", 
            "ja": "手数料", 
            "ko": "수수료", 
            "no": "Gebyrer", 
            "ru": "Комиссии", 
            "sp": "Tarifas", 
            "test": "费用", 
            "tr": "Ücretler", 
            "uk": "Комісії", 
            "zh": "费用"
        }, 
        "label_yourEmail": {
            "ar": "", 
            "de": "", 
            "en": "Your Email", 
            "fr": "Votre Courriel", 
            "he": "", 
            "it": "La tua email", 
            "ja": "あなたのメールアドレス", 
            "ko": "당신의 이메일", 
            "ru": "Адрес Вашей электронной почты", 
            "sp": "", 
            "test": "", 
            "tr": "E-posta adresiniz", 
            "uk": "Адреса Вашої електронної пошти", 
            "zh": "你的邮箱地址"
        }, 
        "label_yourName": {
            "ar": "", 
            "de": "", 
            "en": "Your Name", 
            "fr": "Votre Nom", 
            "he": "", 
            "it": "Il tuo nome", 
            "ja": "あなたの名前", 
            "ko": "당신의 이름", 
            "ru": "Ваше имя", 
            "sp": "", 
            "test": "", 
            "tr": "İsminiz", 
            "uk": "Ваше Ім'я", 
            "zh": "你的名字"
        }, 
        "links": {
            "ar": "", 
            "de": "Links", 
            "en": "Links", 
            "fr": "Liens", 
            "he": "", 
            "it": "Links", 
            "ja": "リンク", 
            "ko": "링크", 
            "no": "Lenker", 
            "ru": "Ссылки", 
            "sp": "Enlaces", 
            "test": "链接", 
            "tr": "Bağlantılar", 
            "uk": "Посилання", 
            "zh": "链接"
        },
        "loading": {
            "en": "Loading...",
            "fr": "Chargement...",
            "it": "Caricamento in corso...",
            "ja": "読み込み中…",
            "ru": "Загрузка...",
            "tr": "Yükleniyor...",
            "uk": "Завантаження...",
            "zh": "加载中..."
        },
        "makeTransaction": {
            "en": "Make a transaction", 
            "fr": "Faire une transaction", 
            "it": "Effettua una transazione", 
            "ja": "トランザクションを実施", 
            "ru": "Сделайте перевод", 
            "tr": "Bir işlem yapın", 
            "uk": "Зробіть переклад", 
            "zh": "做交易"
        }, 
        "myLinks": {
            "en": "My Links", 
            "fr": "Mes liens", 
            "it": "I miei link", 
            "ja": "自分のリンク", 
            "ko": "링크", 
            "ru": "Мои ссылки", 
            "tr": "Bağlantılarım", 
            "uk": "Мої посилання", 
            "zh": "我的链接"
        }, 
        "nodata": {
            "ar": "", 
            "de": "", 
            "en": "No data", 
            "fr": "Pas de données", 
            "he": "", 
            "it": "Nessun dato", 
            "ja": "データなし", 
            "ko": "", 
            "ru": "Нет данных", 
            "sp": "", 
            "test": "", 
            "tr": "Veri yok", 
            "uk": "Немає даних", 
            "zh": "没有数据"
        }, 
        "ok": {
            "en": "Ok", 
            "fr": "Ok", 
            "it": "Ok", 
            "ja": "OK", 
            "tr": "Tamam", 
            "uk": "ОК", 
            "zh": "好"
        }, 
        "pma": {
            "en": "PMA", 
            "fr": "PMA", 
            "it": "PMA", 
            "ja": "PMA", 
            "tr": "PMA", 
            "uk": "PMA", 
            "zh": "PMA"
        }, 
        "professionalMasterAccount": {
            "ar": "", 
            "de": "Professionelles Hauptkonto", 
            "en": "Professional Master Account", 
            "fr": "Compte Principal Professionnel", 
            "he": "", 
            "it": "Conto Professional Master", 
            "ja": "プロフェッショナルマスターアカウント", 
            "ko": "전문가 마스터 계정", 
            "ru": "Профессиональный Мастер-cчёт PMA", 
            "sp": "Cuenta Maestra Profesional", 
            "test": "", 
            "tr": "Profesyonel Ana Hesap", 
            "uk": "Професіональний майстер-рахунок РМА", 
            "zh": "专业主账户"
        }, 
        "questionShort": {
            "en": "Q:", 
            "fr": "Q:", 
            "it": "Q:", 
            "ja": "Q:", 
            "ko": "", 
            "ru": "В:", 
            "tr": "Q:", 
            "uk": "П:", 
            "zh": "问："
        }, 
        "referralProgram": {
            "ar": "", 
            "de": "50x50 Empfehlungsprogramm", 
            "en": "50x50 Referral Program", 
            "fr": "Programme de référence 50x50", 
            "he": "", 
            "it": "Programma di Riferimento 50x50", 
            "ja": "50x50紹介プログラム", 
            "ko": "50x50 추천 프로그램", 
            "no": "50x50 Henvisningsprogram", 
            "ru": "Партнерская программа 50x50", 
            "sp": "Programa de Referencia 50x50", 
            "test": "50x50推荐计划", 
            "tr": "50x50 Referans Programı", 
            "uk": "Партнерська програма 50х50", 
            "zh": "50x50推荐计划"
        }, 
        "reports": {
            "en": "Reports", 
            "fr": "Rapports", 
            "it": "Rapporti", 
            "ja": "レポート", 
            "ru": "Отчеты", 
            "tr": "Raporlar", 
            "uk": "Звіти", 
            "zh": "报告"
        }, 
        "requestSent": {
            "en": "Your request has been successfully sent! Please wait for a response, it will be in 3-5 business days.", 
            "fr": "Votre requête a été envoyée avec succès! Veuillez attendre une réponse, ce sera dans 3-5 jours ouvrables.", 
            "it": "La tua richiesta è stata inviata con successo! Attendi una risposta, entro 3-5 giorni lavorativi.", 
            "ja": "リクエストは正常に送信されました！回答をお待ちください。通常、回答には3〜5営業日かかります。", 
            "ko": "당신의 신청서는 성공적으로 발송되었습니다! 답변을 기다려주세요. 3~5일 안에 답변이 이루어질 예정입니다.", 
            "ru": "Ваш запрос успешно отправлен! Пожалуйста, ожидайте ответа в течение 3-5 рабочих дней.", 
            "tr": "Talebiniz başarıyla gönderildi! Lütfen yanıt için bekleyin, 3-5 iş günü içinde cevaplanacaktır.", 
            "uk": "Ваш запит успішно відправлений! Будь ласка, чекайте відповіді протягом 3-5 робочих днів.", 
            "zh": "您的请求已成功发送！请等待答复，将在3-5个工作日内答复。"
        }, 
        "requestSentShort": {
            "en": "Request has been sent", 
            "fr": "La demande a été envoyée", 
            "it": "La richiesta è stata inviata", 
            "ja": "リクエストが送信されました。", 
            "ru": "Запрос отправлен", 
            "tr": "İstek gönderildi", 
            "uk": "Запит було відправлено", 
            "zh": "请求已发送"
        }, 
        "reward": {
            "en": "Reward", 
            "fr": "Récompense", 
            "it": "Ricompensa", 
            "ja": "報酬", 
            "ko": "", 
            "ru": "Награда", 
            "tr": "Ödül", 
            "uk": "Винагорода", 
            "zh": "奖励"
        }, 
        "shop": {
            "en": "50X100:SHOP", 
            "fr": "50X100:SHOP", 
            "it": "50X100:SHOP", 
            "ja": "50x100:SHOP", 
            "ko": "50X:샵", 
            "tr": "50X100:MAĞAZA", 
            "uk": "50X100:SHOP", 
            "zh": "50X100：商店"
        }, 
        "slogan": {
            "ar": "", 
            "de": "Ihre Trading-Freiheit", 
            "en": "Your Trading Freedom", 
            "fr": "Liberté de trading", 
            "he": "", 
            "it": "Il Tuo Trading Libero", 
            "ja": "あなたに取引の自由を", 
            "ko": "암호화폐 거래의 자유", 
            "no": "Din Handelsfrihet", 
            "ru": "Свобода Трейдинга", 
            "sp": "Libertad en Trading", 
            "test": "您的交易自由", 
            "tr": "Alım Satım  Özgürlüğünüz", 
            "uk": "Свобода Трейдингу", 
            "zh": "你的交易自由"
        }, 
        "smartContract": {
            "en": "Smart contract", 
            "fr": "Contrat intelligent", 
            "it": "Contratto intelligente", 
            "ja": "スマートコントラクト", 
            "ru": "Смарт-контракт", 
            "tr": "Akıllı sözleşme", 
            "uk": "Смарт-контракт", 
            "zh": "智能合约"
        }, 
        "standard": {
            "en": "Standard", 
            "fr": "Standard", 
            "it": "Standard", 
            "ja": "スタンダード", 
            "ru": "Стандарт", 
            "tr": "Standart", 
            "uk": "Стандарт", 
            "zh": "标准"
        }, 
        "statistic": {
            "ar": "", 
            "de": "", 
            "en": "Statistics", 
            "fr": "Statistiques", 
            "he": "", 
            "it": "Statistica", 
            "ja": "統計情報", 
            "ko": "", 
            "ru": "Статистика", 
            "sp": "", 
            "test": "", 
            "tr": "İstatistikler", 
            "uk": "Статистика", 
            "zh": "统计"
        }, 
        "telegram": {
            "ar": "", 
            "de": "", 
            "en": "Telegram Chat", 
            "fr": "Telegram Chat", 
            "he": "", 
            "it": "Chat di Telegram", 
            "ja": "Telegramでのチャット", 
            "ko": "텔레그램", 
            "ru": "Чат Телеграм", 
            "sp": "", 
            "test": "", 
            "tr": "Telegram Sohbeti", 
            "uk": "Чат Тереграм", 
            "zh": "电报聊天"
        }, 
        "ticker": {
            "en": "Tiсker", 
            "fr": "Tiсker", 
            "it": "Tiсker", 
            "ja": "ティッカー", 
            "ru": "Тикер", 
            "tr": "Tiсker", 
            "uk": "Тікер", 
            "zh": "股票行情"
        }, 
        "tokenInfo": {
            "en": "Token Details", 
            "fr": "Détails du jeton", 
            "it": "Dettagli sul Gettone", 
            "ja": "トークンの詳細", 
            "ru": "Информация о токене", 
            "tr": "Token Detayları", 
            "uk": "Інформація про токен", 
            "zh": "代币详细信息"
        }, 
        "tokens50X": {
            "de": "50X Token", 
            "en": "50X TOKENS", 
            "fr": "50X Jetons", 
            "it": "50X Token", 
            "ja": "50Xトークン", 
            "ko": "50X 토큰", 
            "ru": "Токены 50X", 
            "sp": "50X Tokens", 
            "tr": "50X TOKENLER", 
            "uk": "Токени 50X", 
            "zh": "50X 代币"
        }, 
        "tokens50X100": {
            "de": "50X100 Token", 
            "en": "50X100 TOKENS", 
            "fr": "50X100 Jetons", 
            "it": "50X100 Token", 
            "ja": "50X100トークン", 
            "ko": "50X100 토큰", 
            "ru": "Токены 50X100", 
            "sp": "50X100 Tokens", 
            "tr": "50X100 TOKENLER", 
            "uk": "Токени 50X100", 
            "zh": "50X100代币"
        }, 
        "tradeTerminal": {
            "ar": "", 
            "de": "Trading-Terminal", 
            "en": "Trade Terminal", 
            "fr": "Terminal de Trading", 
            "he": "", 
            "it": "Terminale di Trading", 
            "ja": "トレードターミナル", 
            "ko": "Trade Terminal", 
            "no": "Tradingterminal", 
            "ru": "Торговый терминал", 
            "sp": "Terminal de Trade", 
            "test": "交易终端机", 
            "tr": "Alım Satım Terminali", 
            "uk": "Торговий термінал", 
            "zh": "交易终端机"
        }, 
        "url": {
            "en": "URL", 
            "fr": "URL", 
            "it": "URL", 
            "ja": "URL", 
            "tr": "URL", 
            "uk": "URL", 
            "zh": "网址"
        }, 
        "warning": {
            "ar": "", 
            "de": "Achtung!", 
            "en": "Warning!", 
            "fr": "Attention!", 
            "he": "", 
            "it": "Avvertimento!", 
            "ja": "警告！", 
            "ko": "경고!", 
            "ru": "Внимание! Важно!", 
            "sp": "¡Advertencia!", 
            "test": "", 
            "tr": "Uyarı!", 
            "uk": "Увага! Важливо!", 
            "zh": "警告！"
        }, 
        "warningContract": {
            "en": "Do not transfer ETH to the token's smart contract address of your ETH will be lost!", 
            "fr": "Ne transférez pas ETH à l'adresse du contrat intelligent du jeton de votre ETH sera perdu!", 
            "it": "Non trasferire ETH all'indirizzo smart contract del token del tuo ETH andrà perso!", 
            "ja": "トークンのスマートコントラクトアドレスにETHを転送しないでください。ETHが失われてしまいます！", 
            "ru": "Не вздумайте переводить ETH на адрес смарт-контракта токена, это приведет к его потере!", 
            "tr": "Kaybolacak ETH'nizin token akıllı sözleşme adresinden ETH transferi yapmayın!", 
            "uk": "Не здумайте переводити ETH на адресу смарт-контракту токена, це призведе до його втрати!", 
            "zh": "不要将ETH转移到代币的智能合约地址，否则您的ETH将丢失！"
        },
        "whereToBuy": {
            "en": "Where to buy", 
            "ru": "Где купить", 
            "fr": "Où acheter", 
            "it": "Dove acquistare", 
            "ja": "購入場所", 
            "tr": "Nereden alınır", 
            "uk": "Де купити", 
            "zh": "在哪里购买"
        }, 
        "whitepaper": {
            "ar": "", 
            "de": "", 
            "en": "Whitepaper", 
            "fr": "Dossier Technique", 
            "he": "", 
            "it": "Carta bianca", 
            "ja": "ホワイトペーパー", 
            "ko": "백서", 
            "ru": "Белая книга", 
            "sp": "", 
            "test": "", 
            "tr": "Tanıtım yazısı", 
            "uk": "Біла книга", 
            "zh": "白皮书"
        }, 
        "withdrawal": {
            "en": "Withdrawal", 
            "fr": "Retrait", 
            "it": "Prelievo", 
            "ja": "出金", 
            "ko": "출금하기", 
            "ru": "Вывод", 
            "tr": "Para çekme işlemleri", 
            "uk": "Виведення", 
            "zh": "提款"
        }, 
        "withdrawals": {
            "en": "Withdrawals", 
            "fr": "Prélèvements", 
            "it": "Prelievi", 
            "ja": "出金", 
            "ko": "출금하기", 
            "ru": "Выводы", 
            "tr": "Para çekme işlemleri", 
            "uk": "Виведення", 
            "zh": "提款"
        }
    }
}